<template>
  <div class="md-layout case-view-wrapper">
    <div class="_portalRoot">
      <portal to="sidepanel-portal-service-feed">
        
        <md-tabs :md-active-tab="activeEditorTab">
          <md-tab id="tab-comment" md-label="Comment" :class="{ _isActive: 'tab-comment' == activeEditorTab }">
            
            <!-- active editor -->
            <div v-show="showEditorFlag">
              <!-- internal checkbox -->
              <md-checkbox
                class="_isInternalCheckbox"
                v-show="$Session && $Session.isInternalGroupMember"
                v-model="isCommentInternal"
              >Internal</md-checkbox>
              
              <!-- submit button -->
              <md-button class="md-sm md-success _submitTinyMceBtn" :disabled="isCommentButtonDisabled" @click="sendComment">
                <i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">send</i>
              </md-button>
              
              <!-- tinymce editor -->
              <TinyMceEditor
                v-model="comment.body"
                theId="comment"
                :isComment="true"
                :mentionArr="userListItems"
                :attachments="attachmentData"
                @itemSelected="commentItemSelected"
                @success="onUploadSuccess"
              />
              
              <!-- attachments -->
              <div>
                <md-card-actions md-alignment="left" v-if="!attachmentData.length">
                  <md-button class="md-simple md-just-icon _attachFileBtn">
                    <i class="material-icons" v-on:click="onUpload()">attachment</i>
                  </md-button>
                  <span v-if="attachmentData == null">Browse or attach file here</span>
                </md-card-actions>
                <md-card-content v-if="attachmentData.length" class="attachment-area">
                  <div class="md-layout">
                    <md-card-actions md-alignment="left">
                      <md-button class="md-simple md-just-icon _attachFileBtn">
                      <i class="material-icons" v-on:click="onUpload()">attachment</i>
                    </md-button>
                    </md-card-actions>
                    <div class="md-layout-item">
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item md-large-size-25 md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-for="(attachment, chunkIndex) in attachmentData" v-bind:key="chunkIndex">
                          <div v-show="attachment.file.name" class="attchment-card">
                            <div class="attchment-container">{{ attachment.file.name }} ({{ attachment.file.size | kb }} kb)
                              <button type="button" class="attachment-button" title="Remove" @click="removeFile(chunkIndex)" >x</button>
                            </div>
                            <!-- <md-checkbox 
                              class="attachment-area__checkbox" 
                              v-show="$Session && $Session.isInternalGroupMember"
                              v-model="isInternal"
                            >Internal</md-checkbox> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </md-card-content>
                <md-card-actions md-alignment="right">                
                  <md-button class="md-sm md-danger" 
                    @click="closeEditor('comment')"
                  >
                    <i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">close</i> Cancel
                </md-button>
                </md-card-actions>
              </div>
            </div>
            
            <!-- enable message editor -->
            <div v-show="!showEditorFlag" @click="showEditor('comment')">
              Write your comment here.
            </div>
            
          </md-tab>
        </md-tabs>
        
        <div class="dynamicList-loading" v-show="isPromisePending || !recordData">
          <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
        </div>
        <FilterMessageList @filter="onMessagesAndNotesFilterChange" :items="messagesAndNotes" />
        <CaseFeed 
          :items="messagesAndNotesActive" 
          :serviceId="$route.params.id" 
          :userListItems="userListItems" 
          :atReply="onReply" 
          :atCommentEdit="onCommentEdit"
          :atShowAttachment="onShowAttachment"
          :manualCase="manualCase"
        />
        <md-button 
          class="md-sm md-primary" 
          @click="loadNextMessagesAndNotes" 
          title="Load More" 
          v-if="messagesAndNotesHasMore"
        >Load More</md-button>
      </portal>
    </div>
    <div v-if="$route.params.id" id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon :class="formConfig.headerIcon" class="icon-color">{{formConfig.headerIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color content-wrap">{{ pageHeading }}</h1>
        <h2 v-if="recordData && recordData.merchantNumber">MID: {{ recordData.merchantNumber }}</h2>
      </div>
    </div>
    
    <!-- <portal to="sidepanel-portal-service-attachments">
      <Attachments
        v-if="recordData && recordData.id"
        ref="attachmentsListRefs"
        :relations="[{
          fromModelType: 'Service', relationServiceId: recordData.id }
        ]"
        :filter="{
          bool: {
            must: [
              { match_phrase: { relationServiceId: recordData.id } },
              { match_phrase: { fromModelType: 'Service' } },
              { match_phrase: { toModelType: 'Attachment' } },
            ]
          }
        }"
      />
    </portal> -->
    
    <template
      v-if="$route.params.id">

        <md-tabs md-sync-route ref="topPageTabs" class="topNavTabs" :class="[
                  { 'edit-mode': formConfig.pageMode == 'new' || formConfig.pageMode == 'edit' },
                ]">

        <template slot="md-tab" slot-scope="{ tab }">
          <div v-if="tab.data.isCasesTab">
            <span>{{ tab.label }}</span>
            <ServiceCases v-if="recordData && recordData.cases && recordData.cases.items && recordData.cases.items.length"
              :routeParamsId= "$route.params.id"
              :caseListData= "casesList"
              :caseMapFilter="caseServiceIdFilter"
              :caseServiceRelateRecordInput="caseServiceRelateRecordInput"
              ref="hoverCasesTabRef"
            />
          </div>
          <div v-if="tab.data.isAttachmentsTab">
            <span style="padding-right: 25px;">{{ tab.label }}</span>
            <i class="badge">{{ totalAttachmentsCount }}</i>
          </div>
          <div v-if="!tab.data.isCasesTab && !tab.data.isAttachmentsTab">{{ tab.label }}</div>
        </template>

        <md-tab id="tab-service" md-label="Service" :to="recordPath" exact>
          <ProgressStatus v-if="recordData && progressStatus" :list="progressStatus" :currentStatus="currentStatus"></ProgressStatus>
          <div class="md-card md-layout-item md-small-size-100" >
            <ConfigForm 
              :update="updateForm" 
              :form="form" 
              :$v="$v" 
              :formConfig="formConfig" 
              :recordData="recordData" 
              :headerColor="headerColor" 
              :atShowAuditLog="onAuditDialogOpen"
              :isShowBadge="isShowBadge"
            ></ConfigForm>
          </div>
        </md-tab>

        <!-- Case Tab -->
        <md-tab id="tab-cases" md-label="Cases" :to="recordPath + '/cases'" :md-template-data="{ isCasesTab: true }">
          <CaseTab
            v-if="$route && $route.meta.tab === 'cases'" 
            :routeParamsId= "$route.params.id" 
            :caseListData= "casesList"
            :caseMapFilter="caseServiceIdFilter"
            :relateRecordInput="caseServiceRelateRecordInput"
            ref="caseTabRef"
          />
        </md-tab>

        <!-- Task Tab -->
        <md-tab id="tab-tasks" md-label="Tasks" :to="recordPath + '/tasks'">
          <TaskTab
            v-if="$route && $route.meta.tab === 'tasks'" 
            :routeParamsId= "$route.params.id" 
            :taskListData= "tasksList"
            :filter="taskServiceIdFilter"  
          />
        </md-tab>

        <!-- Products tab -->
        <md-tab id="tab-products" md-label="Products" :to="recordPath + '/products'">
          <ColapsibleElasticList
            v-if="$route && $route.meta.tab === 'products'" 
            :list.sync="productsList" 
            :filter="productServiceServiceId" 
            ref="productsListRef"
            :expandParentList="expandParentList"
            :expandChildList="expandChildList"
          ></ColapsibleElasticList>

          <!-- LINK Product dialog -->
          <md-dialog :md-active.sync="productsList.showRelatedDialog">
            <md-dialog-title>{{relateProductsList.pageTitle}}</md-dialog-title>

            <md-dialog-content>
              <ElasticList
                v-if="recordData"
                :list.sync="relateProductsList"
                :filter="productAccountIdFilter"
                :exclude="relateProductServiceFilter"
                :relateRecordInput="{productServiceProductId: null, productServiceServiceId: $route.params.id}"
                relateRecordInputField="productServiceProductId"
              ></ElasticList>
            </md-dialog-content>

            <md-dialog-actions>
              <md-button class="md-theme-default" @click="productsList.showRelatedDialog = false">Close</md-button>
            </md-dialog-actions>
          </md-dialog>

          <!-- ATLAS-1395: <Service><Products> Update Add Product Dialog New -->
          <md-dialog class="__customize" :md-active.sync="productsList.showAddNewModal">
            <md-dialog-title>Add Product</md-dialog-title>
            <md-dialog-content>
              <AddProductModal
                :productsList.sync="productsList"
                :productAccountId="form.serviceAccountId"
                :account="recordData ? recordData.account : null"
                productAccountAlert=""
              ></AddProductModal>
            </md-dialog-content>
          </md-dialog>
        </md-tab>
        
        <!-- Attachments tab -->
        <md-tab id="tab-attachments" md-label="Files" :to="recordPath + '/attachments'" :md-template-data="{ isAttachmentsTab: true }">
          <Attachments
            v-if="recordData && recordData.id"
            ref="attachmentsListRefs"
            :relations="[{
              fromModelType: 'Service', relationServiceId: recordData.id }
            ]"
            :filter="{
              bool: {
                must: [
                  { match_phrase: { relationServiceId: recordData.id } },
                  { match_phrase: { fromModelType: 'Service' } },
                  { match_phrase: { toModelType: 'Attachment' } },
                ]
              }
            }"
            @totalAttachmentsCountChange="onTotalAttachmentsCount"
          />
        </md-tab>
        
      </md-tabs>
    </template>

    <div v-else class="md-tabs topNavTabs md-alignment-left md-theme-default" :class="[
        { 'edit-mode': formConfig.pageMode == 'new' || formConfig.pageMode == 'edit' },
      ]"> 
      <div class="md-content md-tabs-content md-theme-default">
        <div class="md-tabs-container">
          <div id="tab-active" class="md-tab">
            <div class="md-card md-layout-item md-small-size-100">
              <ConfigForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :recordData="recordData" :headerColor="headerColor"></ConfigForm>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-if="formConfig && 'view' == formConfig.pageMode">
      <md-dialog :md-active.sync="isAuditDialogOpen" class="auditLogModal">
        <md-dialog-title>Audit Log</md-dialog-title>
        <md-dialog-content>
          <AuditLogDialog :list.sync="auditLogList" :filter.sync="auditLogFilter"  ref="auditLogListRef"></AuditLogDialog>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button class="md-theme-default" @click="onAuditDialogClose">Close</md-button>
        </md-dialog-actions>
      </md-dialog>
    </template>

    <!-- Upload Dialog -->
    <md-dialog :md-active.sync="isUploadDialogOpen" class="_attachmentsDialog">
      <md-dialog-title>Attachment</md-dialog-title>
      <md-dialog-content>
        <CommentAttachmentsForm
          :docTypes="docTypes"
          :model="attachmentData"
          @success="onUploadSuccess"
        />
      </md-dialog-content>
    </md-dialog>
    
    <md-snackbar
      :md-position="'center'"
      :md-duration="4000"
      :md-active.sync="snackbar.status"
      md-persistent
    >
      <span class="md-sm md-primary">
        {{snackbar.content}} &nbsp;
        <i class="md-icon md-icon-font md-bottom-bar-icon md-accent">{{snackbar.icon}}</i>
      </span>      
    </md-snackbar>

  </div>
</template>

<script>
  import _ from "lodash";
  import moment from "moment";
  import Record from '@/mixins/Record';
  import Page from '@/mixins/Page';
  import Swal from "sweetalert2";

  // Form validations
  import { required, numeric, minLength } from "vuelidate/lib/validators";
  import CaseTab from '@/components/CaseTab';
  import TaskTab from '@/components/TaskTab';
  import ProgressStatus  from "@/components/DynamicForm/ProgressStatus";
  import ColapsibleDynamoList from "@/components/DynamicForm/ColapsibleDynamoList";
  import ColapsibleElasticList from "@/components/DynamicForm/ColapsibleElasticList";
  import AuditLogDialog from "@/components/DynamicForm/AuditLogDialog";
  import Attachments from '@/components/DynamicForm/Attachments/Attachments';

  import aws_exports from "../../aws-exports";
  import Amplify, { Auth, API, graphqlOperation, JS } from "aws-amplify";
  import * as queries from "@/graphql/queries";
  import * as queries_custom from "@/graphql/queries_custom";  
  import * as mutations from '@/graphql/mutations';

  import SidebarToggleBarInfo from '@/components/Sidebar/SidebarToggleBarInfo';
  import CaseFeed from '@/components/CaseFeed';
  import FilterMessageList from '@/components/DynamicForm/FilterMessageList';
  import ServiceCases from '@/components/DynamicForm/ServiceCases';
  import CommentAttachmentsForm from '@/components/DynamicForm/Attachments/CommentAttachmentsForm';
  import TinyMceEditor from '@/components/Editor/TinyMceEditor';
  import AddProductModal from '@/pages/Products/AddProductModal';
  
  import AttachmentMixin from '@/components/DynamicForm/Attachments/Mixins/AttachmentMixin';
  
  import { Storage } from "aws-amplify";
  const { v4: uuidv4 } = require('uuid');

  export default {
    name: "service",
    mixins: [Record, Page, AttachmentMixin],
    components: {
      CaseTab,
      TaskTab,
      ProgressStatus,
      ColapsibleDynamoList,
      ColapsibleElasticList,
      AuditLogDialog,
      Attachments,
      CaseFeed,
      FilterMessageList,
      ServiceCases,
      TinyMceEditor,
      CommentAttachmentsForm,
      AddProductModal
    },
    mounted() {
      this.getUserList();
    },
    computed: {
      isCommentButtonDisabled() {
        let commentStr = this.getCommentAsPlainText();
        return commentStr.length || this.attachmentData.length ? false : true;
      },
      auditLogFilter() { 
        return [
          { match_phrase: { modelName: 'Service' } },
          { match_phrase: { modelId: this.$route.params.id } },
        ]; 
      },
      isAccountClosure: function () {
        return (this.form && (this.form.closeRequested === true || this.form.status === 'Closed'));
      },
      pageHeading: function () {
        let result = '', record = this.recordData;
        if (record) {
          // if (record.account && record.account.name) {
          //   result = record.account.name + ': ' + record.name + ' ' + (record.merchantNumber || '');
          // } else {
            result = record.name;// + ' ' + (record.merchantNumber || '');
          // }
        }
        return result;
      },
      // productServiceIdFilter: function () { return {"productServiceId": {"eq": this.$route.params.id }}; },
      caseServiceRelateRecordInput: function() { return {'caseServiceCaseId': null, 'caseServiceServiceId': this.$route.params.id}},
      caseServiceIdFilter: function() { return {"match": {"caseServiceServiceId.keyword": this.$route.params.id }} },
      productServiceIdFilter: function () { return {"match": {"productServiceId.keyword": this.$route.params.id }}; },
      productServiceServiceId: function() { return {"match_phrase": {"productServiceServiceId": this.$route.params.id }}; },
      productAccountIdFilter: function () { return [{"match": {"productAccountId.keyword": this.recordData.account ? this.recordData.account.id : '' }}] },
      taskServiceIdFilter: function() {
        return [
          {
            match_phrase: {
              taskServiceServiceId: this.$route.params.id
            },
          },
          {
            term: {
              'esData.task.isAvailable': true,
            },
          },
        ];
      },
      relateProductServiceFilter: function() {
        let result = null;
        if (this.recordData && this.recordData.products && this.recordData.products.items) {
          let items = this.recordData.products.items;
          let filters = [];
          items.forEach(item => { 
            filters.push({"match": {"id": item.product.id}});
          });
          if (filters.length) {
            result = {"must_not": filters};
          }
        } 
        return result;
      },
      messagesAndNotesActive() {
        const length = this.messagesAndNotesPage * this.messagesAndNotesItemsPerPage;
        return this.messagesAndNotesFiltered.slice(0, length);
      },
      messagesAndNotesHasMore() {
        return this.messagesAndNotesFiltered.length > this.messagesAndNotesActive.length;
      },
    },
    data() {
      return {
        totalAttachmentsCount: 0,
        attachmentFetchedMessagesId: [],
        shouldShowAlertMessage: true,
        shouldShowAccountAlertMessage: true,
        isUploadDialogOpen: false,
        activeEditorTab: 'tab-comment',
        showEditorFlag: false,
        commentItem: null,
        commentMentionList: [],
        isCommentInternal: false,
        comment: {
          body: '',
          internal: false,
        },
        dialog: {
          'status': false,
          'content': "",
          'confirmText': "Ok!"
        },
        snackbar: {
          'status': false,
          'content': "",
          'icon': "done"
        },
        atMentionsUserList: [],
        onCreateRelationTimeoutId: null,
        isServiceCaseVisible: false,
        isPromisePending: false,
        isShowBadge: false,
        noticationTimeStamp: [],
        expandParentList: [],
        expandChildList: [],
        //for Products tab
        productsList: {
          hideNewRecordButton: true,
          showNewExistingButton: true,
          btnLabel: "Add",
          showAddNewModal: false,
          linkActive: true,
          refreshData: false,
          showRelatedDialog: false,
          editPath: "products",
          pageTitle: "Products",
          pageIcon: "devices",
          itemActions: [
            {
              class: "md-just-icon md-warning md-simple",
              icon: "description",
              click: "handleEdit"
            },
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          listQueryId: "searchServiceProductsCustoms",
          responseFieldName:"searchProductServices",
          deleteQueryId: "deleteProductService",
          deleteQueryIdField: "relateRecordId",
          deleteRelatedQueryId: "deleteProductChild", //custom deleteProductChild relation
          deleteMessageTitle: "Are you sure you want to remove {objectName} from this Service?",
          deleteMessageText: "",
          deleteMessageNameFields: ['name'],
          tableClassName: '_noTableSort',
          columns: {
            'esData.product.name': { label: "Model", sortable: false, esNested: true },
            'esData.product.productOption.name': { label: "Type", sortable: false, esNested: true },
            'esData.product.status': { label: "Status", sortable: false, esNested: true },
            'esData.product.platform': { label: "Platform", sortable: false, esNested: true },
            'esData.product.terminalOrTsysId': { label: "Terminal ID/TSYS TID", sortable: false, esNested: true },
            'esData.product.midV': { label: "MID/V#", sortable: false, esNested: true },
            'esData.product.billingMethod': { label: "Billing Method", sortable: false, esNested: true },
            'esData.product.serial': { label: "Product Serial", sortable: false, esNested: true },
            'esData.product.createdAt': { label: "Created Date", sortable: false, esNested: true, dateFilter: true},
            'esData.product.replacementDate': { label: "Replacement Date", sortable: false, esNested: true}
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            //let product = {};

            if (data && data.searchProductServices && data.searchProductServices.items.length) {
              this.$c.log('formatResponse searchProductServices: ', data.searchProductServices.items);
              data.searchProductServices.items.forEach((item) => {
                if(item.esData){
                  //filter product to skip child items
                  if (!item.product.isChild) {
                    item.relateRecordId = item.id;
                    item.id = item.product.id;
                    item.name = item.product.name;
                    item.isParentProduct = (item.product.children && item.product.children.items && item.product.children.items.length) ? true: false;
                    //ATLAS-1396: default expand parent product
                    if (item.isParentProduct) {
                      this.expandParentList.push(item.id);
                    }

                    //ATLAS-1740: Output Boolean column value as Active/Inactive
                    let esDataParsed = JSON.parse(item.esData);
                    if (esDataParsed && esDataParsed.product) {
                      esDataParsed.product.status = (esDataParsed.product.status === true) ? 'Active' : 'Inactive';
                    }
                    item.esData = JSON.stringify(esDataParsed);

                    if(item.product.children && item.product.children.items && item.product.children.items.length){
                      item.product.children.items.forEach((item) => {
                        item.child.esData = { product: {} };
                        let esData = item.child.esData
                        esData.product.name = item.child.name;              
                        esData.product.status = (item.child.status === true) ? 'Active' : 'Inactive';
                        esData.product.platform = item.child.platform;
                        esData.product.terminalOrTsysId = item.child.terminalOrTsysId;
                        esData.product.midV = item.child.midV;
                        esData.product.billingMethod = item.child.billingMethod;
                        esData.product.serial = item.child.serial;
                        esData.product.replacementDate = item.child.replacementDate;
                        esData.product.owner = item.child.owner;
                        esData.product.createdAt = item.child.createdAt;
                        esData.product.productOption = item.child.productOption;
                        item.child.esData = JSON.stringify(esData);
                        //ATLAS-1396: default expand child product
                        if (item.child && item.child.id) {
                          this.expandChildList.push(item.child.id);
                        }

                        if(item.child.children && item.child.children.items && item.child.children.items.length){
                          item.child.children.items.forEach((item) => {
                            item.child.esData = { product: {} };
                            let esData = item.child.esData
                            esData.product.name = item.child.name;              
                            esData.product.status = (item.child.status === true) ? 'Active' : 'Inactive';
                            esData.product.platform = item.child.platform;
                            esData.product.terminalOrTsysId = item.child.terminalOrTsysId;
                            esData.product.midV = item.child.midV;
                            esData.product.billingMethod = item.child.billingMethod;
                            esData.product.serial = item.child.serial;
                            esData.product.replacementDate = item.child.replacementDate;
                            esData.product.owner = item.child.owner;
                            esData.product.createdAt = item.child.createdAt;
                            esData.product.productOption = item.child.productOption;
                            item.child.esData = JSON.stringify(esData)                        
                          })
                        }
                      })
                    }
                    result.push(item);
                  }
                }
              })
            }
            return result;
          },
        },

        relateProductsList: {
          hideListHeader: true,
          skipCardLayout: true,
          editPath: "product",
          pageTitle: "Search for Product",
          pageIcon: "device",
          listQueryId: "searchProducts",
          createMutationId: "createProductService",
          deleteQueryId: "deleteProductService",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "post_add",
              iconAdded: "check_circle",
              click: "handleAdd"
            }
          ],
          columns: {
            name: { label: "Name", sortable: true },
            createdAt: { label: "Created", sortable: true, dateFilter: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          paginationScrollDialogTop:'.md-dialog-content',
        },

        casesList: {
          listQueryId: "searchCaseServicesCustom",
          responseFieldName: "searchCaseServices",
          listQueryTarget: "searchCaseServices",
          deleteQueryId: "deleteCaseService",
          filterListQueryId: "getListCaseStatusEnum",
          relateRecordInputField:"caseServiceCaseId",
          createMutationId: "createCaseService",
          caseFromTab: 'Service',
          isSearchRecordsInput: true, //Linker table search issue
          subscriptions: {
            onCreateCaseService: {
              result: null,
              load: true,
              function: (eventData) => {
                this.$c.log('CaseTab SUBSCRIPTION Trigger: onCreateCaseService');
                if (eventData.value.data.onCreateCaseService.service.id === this.$route.params.id) {
                  if (this.$refs.caseTabRef) {
                    this.$refs.caseTabRef.$refs.caseTabListRef.refresh();
                  }
                  if (this.$refs.hoverCasesTabRef) {
                    this.$refs.hoverCasesTabRef.$refs.caseTabListRef.refresh();
                  }
                }
              }
            },
            onUpdateCaseService: {
              result: null,
              load: true,
              function: (eventData) => {
                this.$c.log('CaseTab  SUBSCRIPTION Trigger: onUpdateCaseService');
                if (eventData.value.data.onUpdateCaseService.service.id === this.$route.params.id) {
                  if (this.$refs.caseTabRef) {
                    this.$refs.caseTabRef.$refs.caseTabListRef.refresh();
                  }
                  if (this.$refs.hoverCasesTabRef) {
                    this.$refs.hoverCasesTabRef.$refs.caseTabListRef.refresh();
                  }
                }
              }
            },
            onDeleteCaseService: {
              result: null,
              load: true,
              function: (eventData) => {
                this.$c.log('CaseTab  SUBSCRIPTION Trigger: onDeleteCaseService');
                if (eventData.value.data.onDeleteCaseService.service.id === this.$route.params.id) {
                  // using timeout here as subscriptions trigger immediately but
                  // elasticsearch takes time to update
                  setTimeout(() => {
                    if (this.$refs.caseTabRef) {
                      if (this.$refs.caseTabRef.$refs.caseTabListRef) {
                        this.$refs.caseTabRef.$refs.caseTabListRef.refresh();
                      }
                      if (this.$refs.caseTabRef.$refs.casesListRef) {
                        this.$refs.caseTabRef.$refs.casesListRef.refresh();
                      }
                    }
                    if (this.$refs.hoverCasesTabRef) {
                      if (this.$refs.hoverCasesTabRef.$refs.caseTabListRef) {
                        this.$refs.hoverCasesTabRef.$refs.caseTabListRef.refresh();
                      }
                      if (this.$refs.hoverCasesTabRef.$refs.casesListRef) {
                        this.$refs.hoverCasesTabRef.$refs.casesListRef.refresh();
                      }
                    }
                  }, 1000);
                }
              }
            },
            'onUpdateRelation': {
              result: null,
              load: true,
              function: eventData => {
                let eventRecord = eventData.value.data.onUpdateRelation   
                if (eventRecord.esData) {
                  let esData = JSON.parse(eventRecord.esData);
                  if(esData.fromModelType === 'Service' && esData.service && this.$route.params.id === esData.service.id){
                    this.$c.log('SUBSCRIPTION MATCH!: onUpdateRelation');
                    this.$c.log("eventData: ", eventData);
                    // timeout of 5ms for elastic search
                    setTimeout(() => this.$refs.attachmentsListRefs.onSearch(), 500);
                  }
                }
  
                // this.generateChangeFeed();
                this.updateFormData.getService = this.recordData;
                this.updateFormAfter(this.updateFormData);
                this.formConfig.refreshRecordData = true;
              },
            },
          }
        },
        tasksList: {
          listQueryId: "searchTaskServicesCustoms",
          responseFieldName: "searchTaskServices",
          listQueryTarget: "searchTaskServices",
          deleteQueryId: "deleteTaskService",
          filterListQueryId: "getListTaskStatusEnum",
          // directRecord: true,
          // caseIds: [],
          // defaultStatus: "Open", // ATLAS-962: <Service/Account> <Task> On Service Tasks, make default status filter Open
          isShowCaseAndAssingeeInList: true, // ATLAS-1688: <Service><Task tab>Add Columns Case Name and Assignee on Service -> Tasks tab
        },
        subscriptions: {
          'onCreateProductService': {           
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onCreateProductService');
              let eventRecord = eventData.value.data.onCreateProductService;
              /** Filter out records that do not apply to the Product we are looking at */
              if (this.recordData.id === eventRecord.service.id) {
                // this.$c.log('SUBSCRIPTION MATCH: onCreateProductService');
                // /** Check to see if we have this record in out list currently */
                // let matchingIndex = this.productsList.tableData.findIndex(
                //   tableRow => tableRow.id === eventRecord.product.id
                // );
                // /** if we dont have it... */
                // if (matchingIndex == -1) {
                //   eventRecord.product.relateRecordId = eventRecord.id;
                //   /** Add the record to the top of the list */
                //   this.productsList.tableData.unshift(eventRecord.product);
                // }
                
                // refresh teams list after 1 sec
                setTimeout(() => {
                  this.$refs.productsListRef.refresh();
                  /** Force a refresh on the ConfigForm component */
                  this.formConfig.refreshRecordData = true;
                }, 4000);
              }
            }
          },
          'onDeleteProductService': { 
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onDeleteProductService');
              let eventRecord = eventData.value.data.onDeleteProductService;
              if (this.recordData.id === eventRecord.service.id) {
                // this.$c.log('SUBSCRIPTION MATCH: onDeleteProductService');
                // /** A record matching this Product was deleted, check to make sure we dont have it */
                // let indexToDelete = this.productsList.tableData.findIndex(
                //   tableRow => tableRow.id === eventRecord.product.id
                // );
                // if (indexToDelete !== -1) {
                //   /** Delete the row if we do have it */
                //   this.productsList.tableData.splice(indexToDelete, 1);
                // }
                
                // refresh products list after 1 sec
                setTimeout(() => {
                  this.$refs.productsListRef.refresh();
                  /** Force a refresh on the ConfigForm component */
                  this.formConfig.refreshRecordData = true;
                }, 4000);
              }
            }
          },
          'onDeleteProductChild': { 
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onDeleteProductChild');
              let eventRecord = eventData.value.data.onDeleteProductChild;
              //console.log("eventRecord: ", eventRecord);
              if (eventRecord && eventRecord.id) {
                // refresh products list after 1 sec
                setTimeout(() => {
                  this.$refs.productsListRef.refresh();
                  this.formConfig.refreshRecordData = true;
                }, 800);
              }
            }
          },
          'onCreateChange': {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onCreateChange");
              this.$c.log(eventData);
              const changeData = eventData.value.data.onCreateChange;
              if(
                (
                  changeData.modelName == "Case"
                  && _.includes(this.caseIds, changeData.modelId)
                )
                || (
                  this.recordData
                  && changeData.modelName === 'Service'
                  && changeData.modelId === this.recordData.id
                )
              ) {
                this.changeArr.push(changeData);
                this.generateChangeFeed();
              }
            },
          },
          'onUpdateService': {
            /** display the closed status changed by workflow on progress indicator */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onUpdateService");
              this.$c.log('onUpdateService ',eventData);
              if(eventData.value.data.onUpdateService.status == 'Closed' || eventData.value.data.onUpdateService.status === 'Processing_Live'){
                /** Force a refresh on the ConfigForm component */
                this.formConfig.refreshRecordData = true;
              }
            },
          },
          'onCreateRelation': {
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onCreateRelation");
              this.$c.log(eventData);
              /**
               * Do not repeatedly call form refresh when a new relation is created
               * Only call the most recent in an interval of 3 seconds
               */
              if (this.onCreateRelationTimeoutId) {
                clearTimeout(this.onCreateRelationTimeoutId)
              }
              this.onCreateRelationTimeoutId = setTimeout(() => {
                this.updateFormData.getService = this.recordData;
                this.updateFormAfter(this.updateFormData);
                this.generateChangeFeed();
                this.$refs.attachmentsListRefs.onSearch();
                // this.formConfig.refreshRecordData = true;
              }, 3000);
            },
          },
          'onUpdateRelation': {
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onUpdateService");
              this.$c.log('onUpdateService ',eventData);
              // this.generateChangeFeed();
              this.updateFormData.getService = this.recordData;
              this.updateFormAfter(this.updateFormData);
              this.formConfig.refreshRecordData = true;
            },
          },
          'onDeleteRelation': {
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onUpdateService");
              this.$c.log('onUpdateService ',eventData);
              // this.generateChangeFeed();
              this.updateFormData.getService = this.recordData;
              this.updateFormAfter(this.updateFormData);
              this.formConfig.refreshRecordData = true;
            },
          },
          'onCreateAttachment': {
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onCreateAttachment");
              this.$c.log(eventData);
              // this.generateChangeFeed();
              // this.updateFormData.getService = this.recordData;
              // this.updateFormAfter(this.updateFormData);
              // this.formConfig.refreshRecordData = true;
            },
          },
          'onUpdateAttachment': {
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onUpdateService");
              this.$c.log('onUpdateService ',eventData);
              // this.generateChangeFeed();
              this.updateFormData.getService = this.recordData;
              this.updateFormAfter(this.updateFormData);
              this.formConfig.refreshRecordData = true;
            },
          },
          'onDeleteAttachment': {
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onUpdateService");
              this.$c.log('onUpdateService ',eventData);
              // this.generateChangeFeed();
              this.updateFormData.getService = this.recordData;
              this.updateFormAfter(this.updateFormData);
              this.formConfig.refreshRecordData = true;
            },
          },
          'onCreateMessage': {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onCreateMessage");
              this.$c.log(eventData);
              if (eventData.value.data.onCreateMessage.case && (_.includes(this.caseIds, eventData.value.data.onCreateMessage.case.id))) {
                let caseIndex = _.findIndex(this.recordData.cases.items,function(item) { return item.case.id == eventData.value.data.onCreateMessage.case.id});
                if(caseIndex != -1) {
                  this.recordData.cases.items[caseIndex].case.messages.items.unshift(eventData.value.data.onCreateMessage);
                  this.updateFormData.getService = this.recordData;
                  this.updateFormAfter(this.updateFormData);
                }                
              }              
            }
          },
          'onCreateNote': {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onCreateNote");
              this.$c.log(eventData);
              if (eventData.value.data.onCreateNote.case && (_.includes(this.caseIds, eventData.value.data.onCreateNote.case.id))) {
                let caseIndex = _.findIndex(this.recordData.cases.items,function(item) { return item.case.id == eventData.value.data.onCreateNote.case.id});
                if(caseIndex != -1) {
                  this.recordData.cases.items[caseIndex].case.notes.items.unshift(eventData.value.data.onCreateNote);
                  this.updateFormData.getService = this.recordData;
                  this.updateFormAfter(this.updateFormData);
                }
              }
              
            }
          },
          'onDeleteNote': {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onDeleteNote");
              this.$c.log(eventData);
              if (eventData.value.data.onDeleteNote.case && (_.includes(this.caseIds, eventData.value.data.onDeleteNote.case.id))) {
                let caseIndex = _.findIndex(this.recordData.cases.items,function(item) { return item.case.id == eventData.value.data.onDeleteNote.case.id});
                if(caseIndex != -1) {
                  let indexToDelete = _.findIndex(this.recordData.cases.items[caseIndex].case.notes.items, {
                    id: eventData.value.data.onDeleteNote.id
                  });
                  this.recordData.cases.items[caseIndex].case.notes.items.splice(indexToDelete, 1);
                  this.updateFormData.getService = this.recordData;
                  this.updateFormAfter(this.updateFormData);
                }
              }
              
            }
          },
          'onUpdateNote': {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onUpdateNote");
              this.$c.log(eventData);
              if (eventData.value.data.onUpdateNote.case && (_.includes(this.caseIds, eventData.value.data.onUpdateNote.case.id))) {
                let caseIndex = _.findIndex(this.recordData.cases.items,function(item) { return item.case.id == eventData.value.data.onUpdateNote.case.id});
                if(caseIndex != -1) {
                  let indexToUpdate = _.findIndex(this.recordData.cases.items[caseIndex].case.notes.items, {
                    id: eventData.value.data.onUpdateNote.id
                  });
                  this.recordData.cases.items[caseIndex].case.notes.items[indexToUpdate] = eventData.value.data.onUpdateNote;
                  this.updateFormData.getCase = this.recordData;
                  this.updateFormAfter(this.updateFormData);
                }
              }
              
            }
          },
          'onCreateComment': {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onCreateComment");
              this.$c.log(eventData);

              const commentData = eventData.value.data.onCreateComment;
              const isInternalUser = this.$Session.isInternalGroupMember;
              const comments = this.$reduce(this, 'recordData.comments.items');

              // internal comment
              if (commentData.internal && !isInternalUser) {
                return;
              }

              // search comment in service comments
              if (commentData && commentData.parentComment && comments && comments.length) {
                for (const _comment of comments) {
                  if (_comment.id === commentData.parentComment.id) {
                    if (!_comment.comments || !_comment.comments.items) {
                      _comment.comments.items = [];
                    }
                    _comment.comments.items.push(commentData);
                    return;
                  }
                }
              }
              
              // insert comment as a new service comment
              if (commentData && commentData.service &&  commentData.service.id === this.recordData.id) {
                if (!comments || !comments.length) {
                  this.recordData.comments.items = [];
                }
                this.recordData.comments.items.push(commentData);
                commentData._type = 'serviceComment';
                this.messagesAndNotes.unshift(commentData);
                return;
              }
              
              if (eventData.value.data.onCreateComment.message && eventData.value.data.onCreateComment.message.case && (_.includes(this.caseIds, eventData.value.data.onCreateComment.message.case.id)) ||
              eventData.value.data.onCreateComment.note && eventData.value.data.onCreateComment.note.case && (_.includes(this.caseIds, eventData.value.data.onCreateComment.note.case.id))) {
                let commentOn = 'note', commentObject = 'notes';
                if (eventData.value.data.onCreateComment.message) {
                  commentOn = 'message';
                  commentObject = 'messages';
                }
                let caseIndex = _.findIndex(this.recordData.cases.items,function(item) { return item.case.id == eventData.value.data.onCreateComment[commentOn].case.id});
                if(caseIndex != -1) {
                  let addToId = eventData.value.data.onCreateComment[commentOn].id;
                  let indexToAdd = _.findIndex(this.recordData.cases.items[caseIndex].case[commentObject].items, {
                    id: addToId
                  });
                  console.log(indexToAdd);
                  this.recordData.cases.items[caseIndex].case[commentObject].items[indexToAdd].comments.items.unshift(eventData.value.data.onCreateComment);
                  this.updateFormData.getService = this.recordData;
                  this.updateFormAfter(this.updateFormData);
                }
              } else {
                this.updateFormData.getService = this.recordData;
                this.updateFormAfter(this.updateFormData);
                this.formConfig.refreshRecordData = true;
              }
            }
          },
          'onDeleteComment': {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onDeleteComment");
              this.$c.log(eventData);
              if (eventData.value.data.onDeleteComment.message && eventData.value.data.onDeleteComment.message.case && (_.includes(this.caseIds, eventData.value.data.onDeleteComment.message.case.id)) ||
              eventData.value.data.onDeleteComment.note && eventData.value.data.onDeleteComment.note.case && (_.includes(this.caseIds, eventData.value.data.onDeleteComment.note.case.id))) {
                let commentOn = 'note', commentObject = 'notes';
                if (eventData.value.data.onDeleteComment.message) {
                  commentOn = 'message';
                  commentObject = 'messages';
                }
                let caseIndex = _.findIndex(this.recordData.cases.items,function(item) { return item.case.id == eventData.value.data.onDeleteComment[commentOn].case.id});
                if(caseIndex != -1) {
                  let commentOn = 'note', commentObject = 'notes';
                  if (eventData.value.data.onDeleteComment.message) {
                    commentOn = 'message';
                    commentObject = 'messages';
                  }
                  let deleteFromId = eventData.value.data.onDeleteComment[commentOn].id;
                  let findIndexToDelete = _.findIndex(this.recordData.cases.items[caseIndex].case[commentObject].items, {
                    id: deleteFromId
                  });                  
                  let indexToDelete = _.findIndex(this.recordData.cases.items[caseIndex].case[commentObject].items[findIndexToDelete].comments.items, {
                    id: eventData.value.data.onDeleteComment.id
                  });
                  this.recordData.cases.items[caseIndex].case[commentObject].items[findIndexToDelete].comments.items.splice(indexToDelete, 1);                
                  this.updateFormData.getService = this.recordData;
                  this.updateFormAfter(this.updateFormData);
                }
              } else {
                this.updateFormData.getService = this.recordData;
                this.updateFormAfter(this.updateFormData);
                this.formConfig.refreshRecordData = true;
              }
            }
          },
          'onUpdateComment': {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onUpdateComment");
              this.$c.log(eventData);
              if (eventData.value.data.onUpdateComment.message && eventData.value.data.onUpdateComment.message.case && (_.includes(this.caseIds, eventData.value.data.onUpdateComment.message.case.id)) ||
              eventData.value.data.onUpdateComment.note && eventData.value.data.onUpdateComment.note.case && (_.includes(this.caseIds, eventData.value.data.onUpdateComment.note.case.id))) {
                let commentOn = 'note', commentObject = 'notes';
                if (eventData.value.data.onUpdateComment.message) {
                  commentOn = 'message';
                  commentObject = 'messages';
                }                
                let caseIndex = _.findIndex(this.recordData.cases.items,function(item) { return item.case.id == eventData.value.data.onUpdateComment[commentOn].case.id});
                if(caseIndex != -1) {
                  let updateFromId = eventData.value.data.onUpdateComment[commentOn].id;
                  let findIndexToUpdate = _.findIndex(this.recordData.cases.items[caseIndex].case[commentObject].items, {
                    id: updateFromId
                  });                  
                  let indexToUpdate = _.findIndex(this.recordData.cases.items[caseIndex].case[commentObject].items[findIndexToUpdate].comments.items, {
                    id: eventData.value.data.onUpdateComment.id
                  });
                  this.recordData.cases.items[caseIndex].case[commentObject].items[findIndexToUpdate].comments.items[indexToUpdate] = eventData.value.data.onUpdateComment;
                  this.updateFormData.getService = this.recordData;
                  this.updateFormAfter(this.updateFormData);
                }
              } else {
                this.updateFormData.getService = this.recordData;
                this.updateFormAfter(this.updateFormData);
                this.formConfig.refreshRecordData = true;
              }
            }
          },
        },
        formConfig: {
          atShowAuditLog: this.onAuditDialogOpen,
          hasUpdatedBy: true,
          updatedByFieldName: 'serviceUpdatedById',
          responseFieldName: 'getService',
          removeFields: ['portfolios', 'servicePortfolioId'],
          createServicePortfolioRecord: true,
          actions: {
            save: 'createService',
            view: 'getService',
            edit: 'editService',
            new: 'newService',
            update: 'updateService',
            delete: 'deleteService',
          },
          listPath: "/services",
          headerIcon: 'styles',
          objectName: 'Service',
          objectNamePlural: 'Services',
          editMode: false,
          pageMode: 'new', // can be one of ['new', 'view' 'edit']
          slots: {
            basic: {label: 'Service Information', icon: 'work', layout:           {"x":0,"y":0,"w":12,"h":12,"i":"0"}, id:'ServiceInformation'},
            contact: {label: 'Address', icon: 'place', layout:                    {"x":0,"y":12,"w":12,"h":12,"i":"1"}, id:'Address'},
            status: {label: 'Status', icon: 'traffic', layout:                    {"x":0,"y":24,"w":12,"h":12,"i":"2"}, id:'Status'},
            banking: {label: 'Banking Information', icon: 'attach_money', layout: {"x":0,"y":36,"w":12,"h":12,"i":"3"}, id:'BankingInformation'},

            cardtypes: {label: 'Card Types', icon: 'credit_card', layout:         {"x":0,"y":60,"w":12,"h":12,"i":"5"}, id:'CardTypes'},
            business: {label: 'Business Information', icon: 'store', layout:      {"x":0,"y":72,"w":12,"h":12,"i":"6"}, id:'BusinessInformation'},
            close: {label: 'Account Closure', icon: 'work', layout:               {"x":0,"y":84,"w":12,"h":12,"i":"7"}, id:'AccountClosure'},
          },
          fields: {
            id: { label: "ID", type: "id", slot: 'basic' },
            namePrevious: { label: "Previously Known As", type: "text", slot: "basic", classList: "serviceNamePreviousField" },
            isRestructured: { label: "Restructured", type: "checkbox", slot: 'basic' },
            IPCorp: { label: "IPCorp", type: "checkbox", slot: 'basic', value: false },
            isWithdrawalAccount: { label: "Withdrawal Account", type: "checkbox", slot: 'basic' },
            //beta: { label: "BETA", type: "checkbox", slot: 'basic', value: false },
            pilot: { label: "Pilot", type: "checkbox", slot: 'basic' },
            name: { label: "DBA Name", type: "text", slot: 'basic' },
            merchantNumber: { label: "Merchant #", type: "text", slot: 'basic' },
            nameLegal: { label: "Legal Name", type: "text", slot: 'basic' },
            portfolios: {
              hide: () => {
                return this.formConfig.pageMode === 'new';
              },
              label: "Portfolios", type: "searchmodal", slot: 'basic',
              filter: {match: { status: true }},
              subscribe: {
                'onCreate': {
                  'model': 'PortfolioService',
                  'inputField': 'portfolios',
                  'target': 'portfolio'
                },
                'onDelete': {
                  'model': 'PortfolioService',
                  'inputField': 'portfolios',
                  'target': 'portfolio'
                }
              },
              list: {
                hideNewRecordButton: true,
                hideListHeader: true,
                editPath: "portfolios",
                objectName: "portfolio",
                pageTitle: "Portfolios",
                pageIcon: "folder",
                listQueryId: "searchPortfolios",
                createMutationId: "createPortfolioService",
                deleteQueryId: "deletePortfolioService",
                deleteQueryIdField: "relateRecordId",
                deleteMessageTitle: "Are you sure you want to remove {objectName} from this Portfolio?",
                deleteMessageText: "",
                linkRows: false,
                itemActions: [
                  {
                    class: "md-just-icon md-simple md-warning",
                    classAdded: "item.added? 'check_circle' : 'md-warning'",
                    icon: "post_add",
                    iconAdded: "check_circle",
                    click: "handleAdd"
                  }
                ],
                columns: {
                  name: { label: "Name", sortable: true },
                  createdAt: { label: "Created", sortable: true, dateFilter: true},
                },
                perPageOptions: [5, 10, 20, 25, 50],
                defaults: {
                  sort: 'createdAt',
                  sortDir: 'desc',
                  perPage: 10,
                },
                fuseSearch: null,
                relateRecordInput: {portfolioServicePortfolioId: null, portfolioServiceServiceId: null},
                relateRecordInputField: "portfolioServicePortfolioId",
                relateRecordRouteField: "portfolioServiceServiceId",
              },
            },
            servicePortfolioId: { label: "Portfolio", type: "autocomplete", slot: 'basic',
              hide: () => {
                return this.formConfig.pageMode !== 'new';
              },
              data: [],
              searchTerm: "",
              options: [],
              linkBase: '#/portfolios/',
              setVal: (val) => {
                this.$v.form.servicePortfolioId.$model = val;
              },
              select: (c) => {(($this) => {
                $this.setVal(c.id);
                $this.searchTerm = c.name;
              })(this.formConfig.fields.servicePortfolioId)},
              hasValidation: true,
              isLazyLoadEnabled: true,
              lazyLoadListQueryId: 'searchPortfolios',
              lazyLoadResponseFieldName: 'searchPortfolios',
              lazyLoadSearchableFields: ['name'],
              lazyLoadFilter:{match: { status: true }}, //for active data
              // change: (search) => {(($this) => {
              //   const data = $this.data;

              //   $this.options = new Promise(resolve => {
              //     window.setTimeout(() => {
              //       //if no search text given
              //       if (!search) {
              //         $this.setVal("");
              //         $this.searchTerm = "";
              //         resolve(data)
              //       } else {
              //         const term = search.toLowerCase();
              //         let result = data.filter(({ name }) => name && name.toLowerCase() === term);

              //         if (result.length) {
              //           $this.select(result[0]);
              //         } else {
              //           $this.setVal("");
              //           $this.searchTerm = "";
              //         }
                      
              //         resolve(data.filter(({ name }) => name.toLowerCase().includes(term)));
              //       }
              //     }, 100)
              //   })
              // })(this.formConfig.fields.servicePortfolioId)}
            },
            ownershipType: {label: "Ownership Type", type: "select", slot: "basic", optionType: 'enum',
              hide: () => {
                return !this.form || false //typeof this.form.serviceType === 'undefined' || this.form.accountType !== 'MerchantHQ'
              },
              options: []
            },
            phoneBusiness: { label: "Business Phone", type: "text", slot: 'basic' },
            ein: { label: "Federal Tax ID", type: "text", slot: 'basic' },
            phoneSupport: { label: "Customer Service Phone", type: "text", slot: 'basic' },
            serviceAccountId: { label: "Account", type: "autocomplete", slot: 'basic',
              data: [],
              searchTerm: "",
              options: [],
              linkBase: '#/accounts/',
              setVal: (val) => {
                this.$v.form.serviceAccountId.$model = val;
              },
              select: (c) => {(($this) => {
                $this.setVal(c.id);
                $this.searchTerm = c.name;
              })(this.formConfig.fields.serviceAccountId)},
              hasValidation: true,
              isLazyLoadEnabled: true,
              lazyLoadListQueryId: 'searchAccounts',
              lazyLoadResponseFieldName: 'searchAccounts',
              lazyLoadSearchableFields: ['name'],
            },
            phoneFax: { label: "Business Fax", type: "text", slot: 'basic' },
            //nickname: { label: "Nickname", type: "text", slot: 'basic' },
            description: { label: "Description", type: "text", slot: 'basic' },
            website: { label: "Business Website", type: "text", slot: 'basic' },
            email: { label: "Business Email", type: "text", slot: 'basic' },
            processor: { label: "Processor", type: "select", slot: 'basic', options: [] },
            proposalStatementValue: { label: "Proposal Statement Value ($)", type: "text", slot: 'basic' },
            avgTrxAmount : { label: "Proposal Average Ticket ($)", type: "text", slot: 'basic' },
            serviceType: {label: "Service Type", type: "select", slot: "basic", optionType: 'enum', options: []},
            alertMessage: { label: "Alert Message", type: "text", slot: 'basic' },

            addressPhysical: {
              label: "Physical Address",
              type: "json",
              slot: 'contact',
              hide: () => {
                return false
              },
              fields: {
                street_address: { label: "Street Address", type: "text", slot: 'contact' },
                locality: { label: "City", type: "text", slot: 'contact' }, //City
                region: { label: "State", type: "select", slot: 'contact', optionType: 'enum', options: []}, //State
                postal_code: { label: "Postal Code", type: "text", slot: 'contact' },
                country: {label: "Country", type: "select", slot: "contact", optionType: 'enum', options: []},
              }
            },
            addressMailing: {
              label: "Mailing Address",
              type: "json",
              slot: 'contact',
              hide: () => {
                return false
              },
              fields: {
                street_address: { label: "Street Address", type: "text", slot: 'contact' },
                locality: { label: "City", type: "text", slot: 'contact' }, //City
                region: { label: "State", type: "select", slot: 'contact', optionType: 'enum', options: []}, //State
                postal_code: { label: "Postal Code", type: "text", slot: 'contact' },
                country: {label: "Country", type: "select", slot: "contact", optionType: 'enum', options: []},
              }
            },


            status: {label: "Status", type: "select", slot: "status", options: [], optionType: 'enum', classList: "serviceStatusField"},
            dateUwResult: { label: "Underwriting Outcome Date", type: "datepicker", slot: 'status', format: 'YYYY-MM-DD' },
            dateSubmitted: { label: "Submitted Date", type: "datepicker", slot: 'status', format: 'YYYY-MM-DD' },
            uwResult: { label: "Underwriting Outcome", type: "text", slot: 'status' },
            approvalDate: { label: "Approval Date", type: "datepicker", slot: 'status', format: 'YYYY-MM-DD' },
            dateContractExt: { label: "Contract Extension Date", type: "datepicker", slot: 'status', format: 'YYYY-MM-DD' },
            dateFirstProcessing: { label: "Processing Live Date", type: "datepicker", slot: 'status', format: 'YYYY-MM-DD' },
            declineReason: {
              label: "Decline Reason",
              type: "select",
              slot: "status",
              options: [],
              optionType: 'enum',
              hide: () => {
                return (this.form && this.form.status !== 'Declined');
              }
            },
            declineNotes: {
              label: "Decline Notes",
              type: "textarea",
              slot: 'status',
              hide: () => {
                return (this.form && this.form.status !== 'Declined');
              }
            },
            pendingResponsibility: {
              label: "Pending Responsibility",
              type: "select",
              slot: "status",
              options: [],
              optionType: 'enum',
              hide: () => {
                return (this.form && this.form.status !== 'Pending');
              }
            },


            bankAccount: {
              label: "Deposit Account",
              type: "json",
              slot: 'banking',
              fields: {
                bankName: { label: "Bank Name", type: "text", slot: 'banking' },
                bankRouting: { label: "Routing Number", type: "text", slot: 'banking' },
                bankAccount: { label: "Account Number", type: "text", slot: 'banking' },
              }
            },
            withdrawalAccount: {
              label: "Withdrawal Account",
              type: "json",
              slot: 'banking',
              fields: {
                bankName: { label: "Bank Name", type: "text", slot: 'banking' },
                bankRouting: { label: "Routing Number", type: "text", slot: 'banking' },
                bankAccount: { label: "Account Number", type: "text", slot: 'banking' },
              },
              hide: () => {
                return !(this.form && this.form.isWithdrawalAccount)
              }
            },

            amex: {label: "American Express", type: "select", slot: "cardtypes", options: []},
            ebtFnsNum: { label: "EBT Food Stamp FNS #", type: "text", slot: 'cardtypes' },
            amexNum: { label: "American Express #", type: "text", slot: 'cardtypes' },
            ebtCashOn: { label: "EBT Cash", type: "checkbox", slot: 'cardtypes' },
            discover: {label: "Discover", type: "select", slot: "cardtypes", options: [], optionType: 'enum'},
            checkServiceVendor: {label: "Check Service Vendor", type: "select", slot: "cardtypes", options: [], optionType: 'enum'},
            discoverNum: { label: "Discover #", type: "text", slot: 'cardtypes' },
            checkServiceNum: { label: "Check Service #", type: "text", slot: 'cardtypes' },
            wexVoyagerOn: { label: "Wex Voyager", type: "checkbox", slot: 'cardtypes' },
            giftVendor: {label: "Gift Card Vendor", type: "select", slot: "cardtypes", options: []},
            wexVoyagerId: { label: "Wright Express (WEX) ID", type: "text", slot: 'cardtypes' },
            giftVendorNum: { label: "Gift Card Vendor # (formerly Gift Services Number)", type: "text", slot: 'cardtypes' },
            esaId: {label: "ESA ID", type: "select", slot: "cardtypes", options: []},
            debitPinOn: { label: "Debit (Pin Based)", type: "checkbox", slot: 'cardtypes' },
            //TODO: DO WE NEED THESE 4?
            // cashCreditSalesM: { label: "Total Monthly Cash and Credit Sales:", type: "text", slot: 'cardtypes' },
            // mcVisaSaleAvg: { label: "Average MC/Visa Sale Amount", type: "text", slot: 'cardtypes' },
            // mcVisaVolM: { label: "Monthly MC/Visa Volume", type: "text", slot: 'cardtypes' },
            // checksCntAvgM: { label: "Average Number of Checks/ACH Monthly", type: "text", slot: 'cardtypes' },


            businessType: {label: "Business Type", type: "select", slot: "business", options: [], optionType: 'enum'},
            busProductsSold: { label: "Types of Products/Services Sold", type: "text", slot: 'business' },
            busSeasonOn: { label: "Seasonal", type: "checkbox", slot: 'business' },
            busSalesLimitM: { label: "Monthly Sales Processing Limit ($)", type: "text", slot: 'business' },
            busSwipePct: { label: "Swiped (Percent)", type: "text", slot: 'business' },
            busKeyPct: { label: "Keyed (Percent)", type: "text", slot: 'business' },
            busWebPct: { label: "Internet (Percent)", type: "text", slot: 'business' },
            busMailPct: { label: "Mail Order (Percent)", type: "text", slot: 'business' },
            busTicketAvg: { label: "Average Ticket Amount ($)", type: "text", slot: 'business' },
            busTicketMax: { label: "High Ticket Amount ($)", type: "text", slot: 'business' },
            busSicCode: { label: "SIC/MCC Code", type: "text", slot: 'business' },
            busSicCodeDesc: { label: "SIC/MCC Code Description", type: "text", slot: 'business' },
            busBusToBus: { label: "Business to Business", type: "text", slot: 'business' },
            busSeasonM: { label: "Months Merchant Will Process", type: "text", slot: 'business' },
            busBusToCon: { label: "Business to Consumer", type: "text", slot: 'business' },
            busSeasonOpenM: { label: "Seasonal Opening Month", type: "text", slot: 'business' },
            busLocationCnt: { label: "Number of Locations", type: "text", slot: 'business' },
            busSeasonCloseM: { label: "Seasonal Closing Month", type: "text", slot: 'business' },
            annualAmount: { label: "Regular Annual Amount", type: "text", slot: 'business' },
            busAgeY: { label: "Time In Business (years)", type: "text", slot: 'business' },
            annualAmountPCI: { label: "PCI Annual Amount", type: "text", slot: 'business' },
            busAgeM: { label: "Time In Business (months)", type: "text", slot: 'business' },
            //TODO: DO WE NEED THESE 4?
            altMonthMinAmount: { label: "Altered Monthly Minimum Amount", type: "text", slot: 'business' },
            totalCashCreditSalesMonthly: { label: "Total Cash Credit Sales Monthly", type: "text", slot: 'business' },
            estAvgMcVisaTicketSaleAmount: { label: "Est Avg MC Visa Ticket Sale Amount", type: "text", slot: 'business' },
            volumeMcVisaOutletMonthly: { label: "Volume MC Visa Outlet Monthly", type: "text", slot: 'business' },

            closeRequested: { label: "Closure Request", type: "switch", slot: 'close' },
            closeDate: { label: "Close Date", type: "datepicker", slot: 'close', format: 'YYYY-MM-DD', hide: () => {
                return !this.isAccountClosure;
              } },
            closeReason: { label: "Reason for Closure", type: "select", slot: "close", options: [], optionType: 'enum', hide: () => {
                return !this.isAccountClosure;
              }  },
            closeResReportDate: { label: "Residual Report Date", type: "datepicker", format: 'YYYY-MM-DD', slot: 'close', hide: () => {
                return !this.isAccountClosure;
              }  },
            closeReasonDetails: { label: "Reason for Closure Details", type: "textarea", slot: 'close', hide: () => {
                return !this.isAccountClosure;
              }  },
            closeResReportRefundDate: { label: "Residual Report Refund Date", type: "datepicker", format: 'YYYY-MM-DD', slot: 'close', hide: () => {
                return !this.isAccountClosure;
              }  },
            closeEtfAmountRes: { label: "ETF Amount on Residual", type: "text", slot: 'close', hide: () => {
                return !this.isAccountClosure;
              }  },
            closeEtfRefundDate: { label: "ETF Refund Date", type: "datepicker", slot: 'close', format: 'YYYY-MM-DD', hide: () => {
                return !this.isAccountClosure;
              }  },
            closeCancelFee: { label: "Cancellation Fee", type: "select", slot: 'close', options: [], optionType: 'enum', hide: () => {
                return !this.isAccountClosure;
              }  },
            closeEtfChargedDate: { label: "ETF Charged Date", type: "datepicker", slot: 'close', format: 'YYYY-MM-DD', hide: () => {
                return !this.isAccountClosure;
              }  },
            closeEtfAmount: { label: "ETF Amount", type: "text", slot: 'close', hide: () => {
                return !this.isAccountClosure;
              }  },
            closeEtfAdjust: { label: "Adjust ETF", type: "checkbox", slot: 'close', hide: () => {
                return !this.isAccountClosure;
              }  },
            serviceCloseEtfWaiveAppoverId: { label: "ETF Waived Approved By", type: "autocomplete", slot: 'close', 
              data: [],
              displayFieldOne: 'given_name', 
              displayFieldTwo: 'family_name',
              searchTerm: "",
              options: [],
              linkBase: '#/users/',
              hide: () => {
                return !this.isAccountClosure;
              },
              setVal: (val) => {
                this.$v.form.serviceCloseEtfWaiveAppoverId.$model = val;
              },
              select: (c) => {(($this) => {
                $this.setVal(c.id);
                $this.searchTerm = c.given_name + ' ' + c.family_name;
              })(this.formConfig.fields.serviceCloseEtfWaiveAppoverId)},
              change: (search) => {(($this) => {
                const data = $this.data;
                $this.options = new Promise(resolve => {
                  window.setTimeout(() => {
                    
                    if (!search) {
                      $this.setVal("");
                      $this.searchTerm = "";
                      resolve(data)
                    } else {
                      const term = search.toLowerCase();
                      let termGivenName = term.split(' ')[0];
                      let termFamilyName = term.split(' ')[1];
                      
                      let resultGivenName = data.filter(({ given_name }) => given_name.toLowerCase() === termGivenName);
                      let resultFamilyName = data.filter(({ family_name }) => family_name.toLowerCase() === termFamilyName);
                      if ((!resultGivenName.length) || (!resultFamilyName.length)) {  
                        $this.setVal("");
                        $this.searchTerm = "";
                      }
                      resolve(data.filter(({ given_name, family_name }) => (given_name + ' ' + family_name).toLowerCase().includes(term)));
                    }
                  }, 100)
                })
              })(this.formConfig.fields.serviceCloseEtfWaiveAppoverId)}
            },
            closeEtfRefundAmount: { label: "ETF Refund Amount", type: "text", slot: 'close', hide: () => {
                return !this.isAccountClosure;
              }  },
            closeEtfWaiveReason: { label: "Reason to Waive ETF",  type: "select", slot: "close", options: [], optionType: 'enum', hide: () => {
                return !this.isAccountClosure;
              }  },
            closeEtfWaiveOther: { label: "ETF Waive Reason Details", type: "textarea", slot: 'close', hide: () => {
                return !this.isAccountClosure;
              }  },
          },
          editTitleField: 'name'
        },
        form: {
          id: "",
          name: "",
          nameLegal: "",
          portfolios: [],
          servicePortfolioId: "",
          description: "",
          pilot: "",
          email: "",
          website: "",
          phone: "",
          phoneExt: "",
          status: "Prospect",
          pendingResponsibility: "",
          merchantNumber: "",
          namePrevious: "",
          isRestructured: '',
          isWithdrawalAccount: false,
          IPCorp: false,
          //beta: false,
          processor: '',
          proposalStatementValue: '',
          phoneBusiness: '',
          ein: '',
          alertMessage: '',
          //nickname: '',
          phoneSupport: '',
          phoneFax: '',
          serviceAccountId: "",
          serviceType: "",
          ownershipType: "",
          approvalDate: "",
          underwritingStatus: "",
          addressMailing: {
            fields: {
              street_address: "",
              locality: "", //City
              region: "", //State
              postal_code: "",
              country: "",
            }
          },
          addressPhysical: {
            fields: {
              street_address: "",
              locality: "", //City
              region: "", //State
              postal_code: "",
              country: "",
            }
          },
          bankAccount: {
            fields: {
              bankName: "",
              bankRouting: "",
              bankAccount: "",
            }
          },
          withdrawalAccount: {
            fields: {
              bankName: "",
              bankRouting: "",
              bankAccount: "",
            }
          },
          avgTrxAmount : "",
          totalCashCreditSalesMonthly: "",
          estAvgMcVisaTicketSaleAmount: "",
          volumeMcVisaOutletMonthly: "",
          dateUwResult: null,
          dateContractExt: null,
          uwResult: "",
          dateOpen: null,
          dateClosed: null,
          businessType: '',
          busSicCode: '',
          busSicCodeDesc: '',
          busProductsSold: '',
          busSalesLimitM: '',
          busTicketAvg: '',
          busTicketMax: '',
          busSwipePct: '',
          busKeyPct: '',
          busWebPct: '',
          busMailPct: '',
          busAgeY: '',
          busAgeM: '',
          busBusToBus: '',
          busBusToCon: '',
          busLocationCnt: '',
          busSeasonOn: '',
          busSeasonM: '',
          busSeasonOpenM: '',
          busSeasonCloseM: '',
          annualAmount: '',
          annualAmountPCI: '',
          altMonthMinAmount: '',
          amex: '',
          amexNum: '',
          discover: '',
          discoverNum: '',
          wexVoyagerOn: '',
          wexVoyagerId: '',
          esaId: '',
          ebtFnsNum: '',
          ebtCashOn: '',
          checkServiceVendor: '',
          checkServiceNum: '',
          giftVendor: '',
          giftVendorNum: '',
          debitPinOn: '',
          closeRequested: '',
          closeDate: '',
          closeReason: '',
          closeReasonDetails: '',
          closeEtfAmountRes: '',
          closeCancelFee: '',
          closeResReportDate: '',
          closeEtfAmount: '',
          closeEtfAdjust: '',
          closeEtfRefundAmount: '',
          closeEtfRefundDate: '',
          closeEtfChargedDate: '',
          serviceCloseEtfWaiveAppoverId: '',
          closeEtfWaiveReason: '',
          closeEtfWaiveOther: '',
          closeResReportRefundDate: '',
          dateSubmitted: null,
          dateFirstProcessing: null,
          declineReason: '',
          declineNotes: ''
        },
        statusOptions: [],
        ownershipTypeOptions: [],
        serviceTypeOptions: [],
        businessTypeOptions: [],
        amexCardTypeOptions: [],
        discoverCardTypeOptions: [],
        esaIdTypeOptions: [],
        checkServiceVendorOptions: [],
        giftVendorOptions: [],
        pendingResponsibilityOptions: [],
        declineReasonOptions: [],
        progressStatus: [],
        currentStatus: '',
        serviceCaseIds: null,
        regionOptions: [],
        countryOptions: [],
        addrPhysicalCountry: "",
        mailingCountry: "",
        isAuditDialogOpen: false,
        auditLogList: {
          class: 'auditLogList',
          hideItemActions: true,
          skipCardLayout: true,
          hideListHeader: true,
          hideNewRecordButton: true,
          searchRecordsInput: false,
          hideActionColumn: true,
          pageTitle: "Change History",
          listQueryId: "searchChangesCustom",
          responseFieldName: "searchChanges",
          columns: {
            user: { label: "Changed By", sortable: false, size: 10 },
            fieldName: { label: "Field", sortable: false, size: 10 },
            oldValue: { label: "Old Value", sortable: false, size: 10 },
            newValue: { label: "New Value", sortable: false, size: 10 },
            createdAt: { label: "Change Date", sortable: true, dateFilter: true, size: 15 },
            //action: { label: "Activity", sortable: false, size: 10 },
            //change: { label: "Change", sortable: false, format: "json", size: 55 },
          },
          //hyperlink config based on admin role
          linkConfigs: this.$Session && this.$Session.isAdminGroupMember ? [
            {
              name: 'user',
              hrefCallback: (column, name, item) => {               
                return '#/users/' + (item.user ? item.userId : "" );
              },
              titleCallback: (column, name, item) => {                           
                  return item.user                
              },
            }
          ] : [],          
          currentSort: "createdAt",
          currentSortOrder: "asc",
          pagination: {
            perPage: 999,
            currentPage: 1,
            total: 0,
            perPageOptions: [5, 10, 20, 25, 50],
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          tableData: [],
          searchedData: [],
          fuseSearch: null,
          assigneeList: [],
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchChanges && data.searchChanges.items.length) {
              let items = data.searchChanges.items;
              items.forEach((item) => {
                /** Format user and change for display */
                // item.userId = item.user ? item.user.id : '';
                // item.user = item.user ? item.user.given_name + ' ' + item.user.family_name : item.owner;
                // item.action = item.action ? item.action.charAt(0).toUpperCase() + item.action.slice(1) : '';
                // item.createdAt = moment(String(item.createdAt)).format('MMM DD, YYYY h:mm:ss a') 
                
                if (item.change)  {
                  //let change = JSON.stringify(JSON.parse(item.change),null,2);
                  let parseItem = JSON.parse(item.change);

                  item.userId = item.user ? item.user.id : '';
                  item.user = item.user ? item.user.given_name + ' ' + item.user.family_name : item.owner;
                  item.action = item.action ? item.action.charAt(0).toUpperCase() + item.action.slice(1) : '';

                  // if deleted attachment log
                  if (item.action == "Remove" && parseItem.toModelType) {
                    const newItem = {
                      fieldName: parseItem.toModelType,
                      newValue: "",
                      oldValue: parseItem.name,
                      userId: item.userId,
                      user: item.user,
                      //action: item.action,
                      createdAt: moment(String(item.createdAt)).format('MMM DD, YYYY h:mm:ss a'),
                      //change: change
                    };
                    result.push(newItem);
                  }

                  Object.keys(parseItem).forEach((k) => {
                    if (k !== "old") {
                      let newVal = parseItem[k];
                      let oldVal = "";
                      if (typeof parseItem[k] === 'object') {
                        newVal = JSON.stringify(parseItem[k]);
                      }

                      //if old field exist set oldValue
                      if (parseItem.old) {
                        oldVal = parseItem.old[k];
                        if (typeof parseItem.old[k] === 'object') {
                          oldVal = JSON.stringify(parseItem.old[k]);
                        }
                      }

                      if (item.action != "Remove") {
                        const newItem = {
                          fieldName: k,
                          newValue: newVal,
                          oldValue: oldVal,
                          userId: item.userId,
                          user: item.user,
                          //action: item.action ? item.action.charAt(0).toUpperCase() + item.action.slice(1) : '',
                          createdAt: moment(String(item.createdAt)).format('MMM DD, YYYY h:mm:ss a'),
                          //change: change
                        };
                        result.push(newItem);
                      }
                    }
                  });

                }
              })
            }
            return this.orderedAuditLog(result)
          },
        },
        userListItems: [],
        manualCase: false,
        messagesAndNotes: [],
        messagesAndNotesFiltered: [],
        messagesAndNotesPage: 1,
        messagesAndNotesItemsPerPage: 50,
        isDeepLinkLoadInProgress: false,
        autocompleteAccountsList: []
      }
    },
    validations() {
      return {
        form: {
          id: {},
          name: {required, minLength: minLength(3)},
          nameLegal: {},
          portfolios: {},
          servicePortfolioId: (this.formConfig.pageMode === "new")
            ? { required, isValid: this.isServicePortfolioIdValid }
            : { isValid: this.isServicePortfolioIdValid },
          description: {},
          pilot: {},
          email: {},
          website: {},
          phone: {},
          phoneExt: {},
          status: {},
          pendingResponsibility: (this.form && this.form.status === 'Pending') ? {required} : {},
          merchantNumber: {},
          namePrevious: {},
          isRestructured: {},
          isWithdrawalAccount: {},
          IPCorp: {},
          //beta: {},
          processor: {required},
          proposalStatementValue: {},
          phoneBusiness: {},
          ein: {},
          alertMessage: {},
          //nickname: {},
          phoneSupport: {},
          phoneFax: {},
          serviceAccountId: {
            required,
            isValid: this.isServiceAccountIdValid,
          },
          serviceType: {required},
          ownershipType: {},
          approvalDate: {},
          underwritingStatus: {},
          addressMailing: {
            fields: {
              street_address: {},
              locality: {},
              region: {},
              postal_code: {},
              country: {},
            }
          },
          addressPhysical: {
            fields: {
              street_address: {},
              locality: {},
              region: {},
              postal_code: {},
              country: {},
            }
          },
          bankAccount: {
            fields: {
              bankName: {},
              bankRouting: {},
              bankAccount: {},
            }
          },
          withdrawalAccount: {
            fields: {
              bankName: {},
              bankRouting: {},
              bankAccount: {},
            }
          },
          avgTrxAmount : {},
          totalCashCreditSalesMonthly:{},
          estAvgMcVisaTicketSaleAmount: {},
          volumeMcVisaOutletMonthly: {},

          // bankAccountFees: {},
          // bankAccountDeposits: {},
          // bankAccountChargebacks: {},

          dateUwResult: {},
          dateContractExt: {},
          uwResult: {},
          dateOpen: {},
          dateClosed: {},
          businessType: {},
          busSicCode: {},
          busSicCodeDesc: {},
          busProductsSold: {},
          busSalesLimitM: {},
          busTicketAvg: {},
          busTicketMax: {},
          busSwipePct: {},
          busKeyPct: {},
          busWebPct: {},
          busMailPct: {},
          busAgeY: {},
          busAgeM: {},
          busBusToBus: {},
          busBusToCon: {},
          busLocationCnt: {},
          busSeasonOn: {},
          busSeasonM: {},
          busSeasonOpenM: {},
          busSeasonCloseM: {},
          annualAmount: {},
          annualAmountPCI: {},
          altMonthMinAmount: {},
          amex: {},
          amexNum: {},
          discover: {},
          discoverNum: {},
          wexVoyagerOn: {},
          wexVoyagerId: {},
          esaId: {},
          ebtFnsNum: {},
          ebtCashOn: {},
          checkServiceVendor: {},
          checkServiceNum: {},
          giftVendor: {},
          giftVendorNum: {},
          debitPinOn: {},
          closeRequested: {},
          closeDate: (this.form && this.form.status === 'Closed') ? {required} : {},
          closeReason: (this.form && this.form.closeRequested == true) ? {required} : {},
          closeReasonDetails: {},
          closeEtfAmountRes: {},
          closeCancelFee: {},
          closeResReportDate: {},
          closeEtfAmount: {},
          closeEtfAdjust: {},
          closeEtfRefundAmount: {},
          closeEtfRefundDate: {},
          closeEtfChargedDate: {},
          serviceCloseEtfWaiveAppoverId: {},
          closeEtfWaiveReason: {},
          closeEtfWaiveOther: {},
          closeResReportRefundDate: {},
          dateSubmitted: {},
          dateFirstProcessing: (this.form && this.form.status === 'Processing_Live') ? {required} : {},
          declineReason: (this.form && this.form.status === 'Declined') ? {required} : {},
          declineNotes: (this.form && this.form.status === 'Declined') ? {required, minLength: minLength(3)} : {}
        },
        caseIds: [],
        changeArr: [],
        updateFormData: {}
      }
    },
    methods: {
      /**
       * When totalAttachmentsCountChange event is emitted from AttachmentsConfig 
       * then update totalAttachmentsCount value
       */
      onTotalAttachmentsCount(value) {
        this.totalAttachmentsCount = value;
      },
      /**
       * Validate portfolio selection
       * @param {String} value the selected portfolio ID
       * @returns {Promise}
       */
      async isServicePortfolioIdValid(value) {
        // normalized value
        const valueNormalized = value.toString().trim();
        
        // current field
        const field = this.formConfig.fields.servicePortfolioId;
        
        // value is empty and there is no search term
        if (!valueNormalized && !field.searchTerm) {
          return true;
        }
        
        // clear existing timeout
        clearTimeout(field.timeoutId);
        
        // query 
        const queryName = 'getPortfolio';
        
        // run new validation
        return new Promise(async (resolve, reject) => {
          field.timeoutId = setTimeout(() => {
            API.graphql(graphqlOperation(queries[queryName], { id: valueNormalized }))
              .then(res => {
                const name = this.$reduce(res, `data.${queryName}.name`);
                if (name === field.searchTerm) {
                  return resolve(true);
                }
                return reject(false);
              })
              .catch(err => {
                return reject(false);
              })
          }, 500);
        });
      },
      /**
       * Validate account selection
       * @param {String} value the selected account ID
       * @returns {Promise}
       */
      async isServiceAccountIdValid(value) {
        // normalized value
        const valueNormalized = value.toString().trim();
        
        // current field
        const field = this.formConfig.fields.serviceAccountId;
        
        // value is empty and there is no search term
        if (!valueNormalized && !field.searchTerm) {
          return true;
        }
        
        // clear existing timeout
        clearTimeout(field.timeoutId);
        
        // query 
        const queryName = 'getAccount';
        
        // run new validation
        return new Promise(async (resolve, reject) => {
          field.timeoutId = setTimeout(() => {
            API.graphql(graphqlOperation(queries[queryName], { id: valueNormalized }))
              .then(res => {
                const name = this.$reduce(res, `data.${queryName}.name`);
                if (name === field.searchTerm) {
                  return resolve(true);
                }
                return reject(false);
              })
              .catch(err => {
                return reject(false);
              })
          }, 500);
        });
      },
      /**
       * At mentions user selected
       * @returns {Void}
       */
      commentItemSelected(item) {
        this.commentMentionList.push(item);
      },
      /**
       * Show attachment upload form
       * @returns {Void}
       */
      onOpenAttachmentDialog() {
        this.isUploadDialogOpen = true;
      },
      /**
       * Show the specified editor
       * @param {String} mode - the editor to be opened
       * @returns {Void}
       */
      showEditor(mode) {
        this.showEditorFlag = true;
        setTimeout(() => { 
          window.$bus.$emit('focusTinyMceEditor', { id: mode });
        }, 300);
      },
      /**
       * Close the specified editor
       * @returns {Void}
       */
      closeEditor(editor) {
        this.$set(this[editor], 'body', '');
        window.$bus.$emit('refreshTinyMceEditor', { id: editor, content: '' });
        this.showEditorFlag = false;
        if (editor === 'comment') {
          this.attachmentData = [];
        }
      },
      /**
       * Clear comment editor
       * @returns Void
       */
      clearCommentEditor () { 
        this.attachmentData = [];
        this.commentItem = null;
        this.isCommentInternal = false;
        this.showEditorFlag = false;
        this.$set(this.comment, 'body', '');
        this.$set(this.comment, 'internal', false);
        window.$bus.$emit('refreshTinyMceEditor', { id: 'comment', content: '' });            
        this.atMentionsUserList.splice(0, this.atMentionsUserList.length);
      },
      /**
       * Get mentioned users
       * @returns Void
       */
      getAtMentionUsers (commentData) {
        this.placeHolder();
        this.commentMentionList.forEach(el => {
          if(commentData.includes(el.name)) {
            if(this.atMentionsUserList.indexOf(el.id) == -1) {
              this.atMentionsUserList.push(el.id);
            }
          }
        });
      },
      /**
       * placeholder() extracts attributes from comment body html,
       * searches @mention user's name and push it into userMentionArray
       * @returns Void
       */
      placeHolder () {
        let userMentionArray = [];
        //match attributes in html string
        let attributes = this.comment.body.match(/[\w-]+="[^"]*"/g);

        if(attributes !== null) {
          attributes.forEach(el => {
            if(el.startsWith('id=')) {
              let replace1 = el.replace('id="', "");
              let replace2 = replace1.replace('"', '');
              //add extracted user name from attributes array in userMentionArray
              userMentionArray.push(replace2);
            }
          });
        }

        //if userMentionArray have data then form commentMentionList
        if(userMentionArray){
          userMentionArray.forEach(ele => {
            let obj = this.userListItems.find(o => o.name === ele);
            if (obj) {
              this.commentMentionList.push(obj);
            }
          });
        }
      },
      /**
       * Send comment
       * @returns {Void}
       */
      async sendComment () {
        let commentStr = this.getCommentAsPlainText();
        if (!commentStr.length) {
          this.promisePending = true;
          await this.storeAttachmentsOnly();
          this.cleanupAfterComment();
          return;
        }
        
        if(this.commentItem) {
          this.promisePending = true;
          
          let updateCommentData = {
            id: this.commentItem.id,
            internal: this.isCommentInternal
          }

          let error = null;
          let s3Key = this.commentItem.s3Url;
          if (!s3Key) {
            s3Key = `comments/${uuidv4()}`;
          }
          
          const s3Response = await Storage
            .put(s3Key, this.comment.body, {
              bucket: aws_exports.aws_user_files_s3_bucket,
              region: aws_exports.aws_user_files_s3_bucket_region,
            })
            .catch(err => {
              error = err;
              console.log('Error uploading comment to S3', err)
            });

          if (error) {
            this.snackbar.icon = 'done';
            this.snackbar.content = error.message || 'Something went wrong. Please try again.';
            this.snackbar.status = true;
            this.promisePending = false;
            return;
          }

          updateCommentData.s3Url = s3Key;

          this.getAtMentionUsers (this.comment.body);

          //update data for atMentions key
          if (this.atMentionsUserList && this.atMentionsUserList.length) {
            let atMentionsList = {
              items: this.atMentionsUserList
            };
            updateCommentData.atMentions = JSON.stringify(atMentionsList);
          } else {
            updateCommentData.atMentions = JSON.stringify({});
          }
          
          /**
           * ATLAS-877 - Add Updatedby to all Models in the Schema
           * @see https://zeamster.atlassian.net/browse/ATLAS-877
           */
          updateCommentData['commentUpdatedById'] = this.$reduce(this, '$Session.userId');

          let gqlRequest = graphqlOperation(mutations['updateComment'], {input: updateCommentData});
          this.$c.log('gqlRequest', gqlRequest);

          const result = await API.graphql(gqlRequest)
          .then(async result => {
            this.$c.log(result);
            
            // the mixins use this.attachments
            this.attachments = this.attachmentData
            this.commentId = result.data.updateComment.id;
            this.add(this.getCommentAttachmentRelations())
              .then(() => {
                this.commentId = null;
                this.attachments = [];
              });
            
            this.snackbar.status = true;
            this.snackbar.content = 'Comment Updated Successfully';
            this.snackbar.icon = 'done';
            
            this.placeHolder();
            this.clearCommentEditor();
            this.promisePending = false;
          })
          .catch(error => {
            this.commentId = null
            this.attachments = []
            this.$c.log(error);
            this.dialog.status = true;
            this.dialog.content = error.errors[0].message;
            this.clearCommentEditor();
            this.promisePending = false;
          });
        } 
        else {
          this.promisePending = true;
          let inputCommentData = {
            internal: this.isCommentInternal,
            commentServiceId: this.$route.params.id,
            commentUserId: this.$Session.userId
          };

          let error = null;
          const s3Key = `comments/${uuidv4()}`;
          const s3Response = await Storage
            .put(s3Key, this.comment.body, {
              bucket: aws_exports.aws_user_files_s3_bucket,
              region: aws_exports.aws_user_files_s3_bucket_region,
            })
            .catch(err => {
              error = err;
              console.log('Error uploading comment to S3', err)
            });

          if (error) {
            this.snackbar.icon = 'done';
            this.snackbar.content = error.message || 'Something went wrong. Please try again.';
            this.snackbar.status = true;
            this.promisePending = false;
            return;
          }

          inputCommentData.s3Url = s3Key;

          this.getAtMentionUsers (this.comment.body);

          //add data for atMentions key
          if (this.atMentionsUserList && this.atMentionsUserList.length) {
            let atMentionsList = {
              items: this.atMentionsUserList
            };
            inputCommentData.atMentions = JSON.stringify(atMentionsList);
          }
      
          /**
           * ATLAS-877 - Add Updatedby to all Models in the Schema
           * @see https://zeamster.atlassian.net/browse/ATLAS-877
           */
          inputCommentData['commentUpdatedById'] = this.$reduce(this, '$Session.userId');

          let gqlRequest = graphqlOperation(mutations['createComment'], {input: inputCommentData});
          this.$c.log('gqlRequest', gqlRequest);
          const result = await API.graphql(gqlRequest)
          .then(async result => {
            this.$c.log(result);
            
            this.commentId = result.data.createComment.id
            this.attachments = this.attachmentData
            await this.add(this.getCommentAttachmentRelations())
              .then(() => {
                this.commentId = null
                this.attachments = []    
              });
            
            this.snackbar.status = true
            this.snackbar.content = 'Comment added successfully'
            this.snackbar.icon = 'done'
            
            this.placeHolder()
            this.clearCommentEditor();
            this.promisePending = false;
          })
          .catch(error => {
            this.commentId = null
            this.attachments = []
            this.promisePending = false;
            this.dialog.status = true;
            if (error.errors && error.errors[0] && error.errors[0].message) {
              this.dialog.content = error.errors[0].message;
            }
            this.$c.log(error);
            this.clearCommentEditor();
          });
        }        
      },
      /**
       * Get attachment relations to service
       * @returns {Array}
       */
      getCommentAttachmentRelations() {
        return [
          { fromModelType: 'Service', relationServiceId: this.recordData.id },
          { fromModelType: 'Comment', relationCommentId: this.commentId },
        ];
      },
      /**
      * Get attachments based on filter
      * @param {Object} filter the filter object
      * @returns {Mixed} Array of attachment models on successs else null
      */
      async getAttachments(filter) {
        return new Promise((resolve, reject) => {
          let operation = graphqlOperation(queries_custom.searchCaseAttachments, { filter, limit: 999 });
          API.graphql(operation)
            .then(async response => {
              // result data
              let result = [];
              let items = this.$reduce(response, 'data.searchRelations.items');

              // s3 bucket base url
              const amplifyEnv = aws_exports.aws_content_delivery_bucket.match(/.*-(\w+)/)[1]
              const s3Bucket = 'atlasemailattachments-' + amplifyEnv

              // scan all attachments
              for (const _item of items) {
                // if attachment was deleted then bail
                if (!_item.attachment || _item.attachment.isDeleted) {
                  continue
                }

                const url = await Storage.get(_item.attachment.s3Path, {
                  bucket: aws_exports.aws_user_files_s3_bucket,
                  region: aws_exports.aws_user_files_s3_bucket_region,
                });
                result.push({
                  id: _item.attachment.id,
                  description: _item.attachment.description,
                  name: _item.attachment.name,
                  s3Key: _item.attachment.s3Path,
                  s3Path: url,
                  type: _item.attachment.type.replace(/_/ig, ' '),
                  internal: _item.attachment.internal
                });
              }
              resolve(result.length > 0 ? result : null);
            })
            .catch(err => {
              console.log('getAttachment - Error', err);
              resolve(null);
            });
          });
      },
      scrollToHash(hash){
        // if(!hash) 
        //   var hash = this.$route.hash.replace('#', '');
        // let parentEle = document.getElementById('sidePanelBody');
        // if (!parentEle) {
        //   parentEle = window;
        // }

        // let element = document.getElementById(hash);
        // if(element) {
        //   const top = element.getBoundingClientRect().top + window.pageYOffset;
        //   parentEle.scrollTo({
        //     top, // scroll so that the element is at the top of the view
        //     behavior: 'smooth' // smooth scroll
        //   })
        // }
      },
      onAuditDialogOpen() {
        this.isAuditDialogOpen = true;
      },
      onAuditDialogClose() {
        this.isAuditDialogOpen = false;
      },
      orderedAuditLog(items) {
        return _.orderBy(items, 'createdAt', 'desc');
      },
      updateFormAfter(data) {
        if (typeof data === 'undefined') return;
        this.updateFormData = data;
        this.generateChangeFeed();
        this.loadDeepLinkMessageOrNote();
        this.scrollToHash();
        this.getStatusEnumOptions(data);
        this.getOwnershipTypeEnumOptions(data);
        this.getserviceTypeEnumOptions(data);
        this.getBusinessTypeEnumOptions(data);
        this.getAmexCardTypeOptions(data);
        this.getDiscoverCardTypeOptions(data);
        this.getEsaIdTypeOptions(data);
        this.getCheckServiceVendorOptions(data);
        this.getGiftVendorOptions(data);
        this.getServiceCloseReasonOptions(data);
        this.getServiceCloseCancelFeeOptions(data);
        this.getServiceCloseEtfWaiveReasonOptions(data);
        this.getPendingResponsibilityEnumOptions(data);
        this.getDeclineReasonEnumOptions(data);

        //State and Country dropdown options
        this.getCountryEnumOptions(data);
        this.getRegionEnumOptions(data);

        this.formatCurrency(data);

        this.$notifyClear(this.noticationTimeStamp);
        this.noticationTimeStamp = [];

        if (this.shouldShowAccountAlertMessage) {
          this.shouldShowAccountAlertMessage = false;
          if (
            this.recordData
            && this.recordData.account
            && this.recordData.account.alert
          ) {
            let timeStamp = this.$notify({
              title: "Account Alert",
              message: this.recordData.account.alert,
              icon: "work",
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
              
            });
            this.noticationTimeStamp.push(timeStamp);
          }
        }

        if (this.shouldShowAlertMessage) {
          this.shouldShowAlertMessage = false;
          if (
            this.recordData
            && this.recordData.alertMessage
          ) {
            let timeStamp = this.$notify({
              title: "Service Alert",
              message: this.recordData.alertMessage,
              icon: "style",
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
              
            });
            this.noticationTimeStamp.push(timeStamp);
          }
        }

        //ATLAS-1600: <Service> Show Premier indicator at Service level if Account is Premier
        if (data && data.getService && data.getService.account && data.getService.account.id) {
          this.isShowBadge = data.getService.account.premier;
        }

        // Update the serviceAccountId auto-complete
        (($this) => {
          //$this.data = data.listAccounts.items;
          $this.data = [];

          //set Account field on view/edit mode
          if (this.recordData && this.recordData.account) { 
            $this.searchTerm = this.recordData.account.name;
            this.form.serviceAccountId = this.recordData.account.id;
          } else {
            //if route contains accountId/serviceAccountId from Account > Service tab > ADD
            if (this.$route.query.serviceAccountId) {
              let accountId = this.$route.query.serviceAccountId;
              this.getAccount(accountId)
                .then(response => {
                  if (response) {
                    $this.searchTerm = response.name;
                    this.$v.form.serviceAccountId.$model = response.id;
                  }
                })
                .catch(err => console.log('getAccount error ', err));
            }
          }
        })(this.formConfig.fields.serviceAccountId);

        // Update the processor auto-complete
        (($this) => {
          let options = [];
          data.listProcessorTypeEnum.enumValues.map(_value => {
            options.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          $this.options = options;
        })(this.formConfig.fields.processor);

        (($this) => {
          $this.data = data.listUsers.items;

          if (this.recordData && this.recordData.closeEtfWaiveAppover) {
            $this.searchTerm = this.recordData.closeEtfWaiveAppover.given_name + ' ' + this.recordData.closeEtfWaiveAppover.family_name;            
            this.form.serviceCloseEtfWaiveAppoverId = this.recordData.closeEtfWaiveAppover.id;
          } 
        })(this.formConfig.fields.serviceCloseEtfWaiveAppoverId);

        //ATLAS-1235: <Service> when create a new service the portfolio field need to be required
        if (this.formConfig.pageMode === 'new') {
          (($this) => {
            //$this.data = data.listPortfolios.items;
            $this.data = [];
          })(this.formConfig.fields.servicePortfolioId);
        } else {
          this.loadRelatedRecords(data, 'portfolios', 'portfolio');
        }

        if (this.recordData) {
          this.$set(this, 'currentStatus', this.recordData.status);

            // if (this.recordData.dateUwResult) {
            // this.form.dateUwResult = new Date(this.recordData.dateUwResult);
            // this.$v.form.dateUwResult.$model = new Date(this.recordData.dateUwResult);
            // this.$v.form.dateUwResult.$reset();
            // }

            // if (this.recordData.dateContractExt) {
            // this.form.dateContractExt = new Date(this.recordData.dateContractExt);
            // this.$v.form.dateContractExt.$model = new Date(this.recordData.dateContractExt);
            // this.$v.form.dateContractExt.$reset();
            // }

            // if (this.recordData.dateOpen) {
            // this.form.dateOpen = new Date(this.recordData.dateOpen);
            // this.$v.form.dateOpen.$model = new Date(this.recordData.dateOpen);
            // this.$v.form.dateOpen.$reset();
            // }

            // if (this.recordData.dateClosed) {
            // this.form.dateClosed = new Date(this.recordData.dateClosed);
            // this.$v.form.dateClosed.$model = new Date(this.recordData.dateClosed);
            // this.$v.form.dateClosed.$reset();
            // }

            /**
             * ATLAS-685 New Application Workflow - Add fields needed to Service model
             * Format date in recordData: dateSubmitted, dateFirstProcessing
             */
            // if(this.recordData.dateSubmitted) {
            //   this.form.dateSubmitted = new Date(this.recordData.dateSubmitted);
            //   this.$v.form.dateSubmitted.$model = new Date(this.recordData.dateSubmitted);
            //   this.$v.form.dateSubmitted.$reset();
            // }

            // if(this.recordData.dateFirstProcessing) {
            //   this.form.dateFirstProcessing = new Date(this.recordData.dateFirstProcessing);
            //   this.$v.form.dateFirstProcessing.$model = new Date(this.recordData.dateFirstProcessing);
            //   this.$v.form.dateFirstProcessing.$reset();
            // }
        }
      },
      loadRelatedRecords(data, name, target) {
        let result = [];
        if (data && data.getService && data.getService[name] && data.getService[name].items && data.getService[name].items.length) {
          let items = data.getService[name].items;
          items.forEach(item => {
            if(item[target]){
              item[target].relateRecordId = item.id;
              result.push(item[target]);
            }

          });
        }
        this.form[name] = result;
      },
      getStatusEnumOptions(data) {
        this.statusOptions = [];
        this.progressStatus = [];
        if (data.listServiceStatuseEnum && data.listServiceStatuseEnum.enumValues) {
          data.listServiceStatuseEnum.enumValues.map(_value => {
            this.statusOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
              key: _value.name.replace(/[a-z]|\_/g, ''),
            });
          });
          this.formConfig.fields.status.options = this.statusOptions;
          this.statusOptions.filter(_item => {
            if(_item.id !== 'Merchant_HQ'){
              if(_item.id === 'Pending') {
                    _item.key = 'PNDG'
              }
              if(_item.id === 'Processing_Live') {
                    _item.key = 'LIVE'
              }
              this.progressStatus.push(_item)
            }
          })
        }
      },
      getOwnershipTypeEnumOptions(data) {
        this.ownershipTypeOptions = [];
        if (data.listOwnershipTypeEnum && data.listOwnershipTypeEnum.enumValues) {
          data.listOwnershipTypeEnum.enumValues.map(_value => {
            this.ownershipTypeOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.ownershipType.options = this.ownershipTypeOptions;
        }
      },
      getserviceTypeEnumOptions(data) {
        this.serviceTypeOptions = [];
        if (data.listServiceTypeEnum && data.listServiceTypeEnum.enumValues) {
          data.listServiceTypeEnum.enumValues.map(_value => {
            this.serviceTypeOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.serviceType.options = this.serviceTypeOptions;
        }
      },
      getBusinessTypeEnumOptions(data) {
        this.businessTypeOptions = [];
        if (data.listBusinessTypeEnum && data.listBusinessTypeEnum.enumValues) {
          data.listBusinessTypeEnum.enumValues.map(_value => {
            this.businessTypeOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.businessType.options = this.businessTypeOptions;
        }
      },
      getAmexCardTypeOptions(data) {
        this.amexCardTypeOptions = [];
        if (data.listAmexCardTypeEnum && data.listAmexCardTypeEnum.enumValues) {
          data.listAmexCardTypeEnum.enumValues.map(_value => {
            this.amexCardTypeOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.amex.options = this.amexCardTypeOptions;
        }
      },
      getDiscoverCardTypeOptions(data) {
        this.discoverCardTypeOptions = [];
        if (data.listDiscoverCardTypeEnum && data.listDiscoverCardTypeEnum.enumValues) {
          data.listDiscoverCardTypeEnum.enumValues.map(_value => {
            this.discoverCardTypeOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.discover.options = this.discoverCardTypeOptions;
        }
      },
      getEsaIdTypeOptions(data) {
        this.esaIdTypeOptions = [];
        if (data.listEsaIdTypeEnum && data.listEsaIdTypeEnum.enumValues) {
          data.listEsaIdTypeEnum.enumValues.map(_value => {
            this.esaIdTypeOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.esaId.options = this.esaIdTypeOptions;
        }
      },
      getCheckServiceVendorOptions(data) {
        this.checkServiceVendorOptions = [];
        if (data.listCheckServiceVendorEnum && data.listCheckServiceVendorEnum.enumValues) {
          data.listCheckServiceVendorEnum.enumValues.map(_value => {
            this.checkServiceVendorOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.checkServiceVendor.options = this.checkServiceVendorOptions;
        }
      },
      getGiftVendorOptions(data) {
        this.giftVendorOptions = [];
        if (data.listGiftVendorEnum && data.listGiftVendorEnum.enumValues) {
          data.listGiftVendorEnum.enumValues.map(_value => {
            this.giftVendorOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.giftVendor.options = this.giftVendorOptions;
        }
      },
      getServiceCloseReasonOptions(data) {
        this.serviceCloseReasonOptions = [];
        if (data.listServiceCloseReasonEnum && data.listServiceCloseReasonEnum.enumValues) {
          data.listServiceCloseReasonEnum.enumValues.map(_value => {
            this.serviceCloseReasonOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.closeReason.options = this.serviceCloseReasonOptions;
        }
      },
      getServiceCloseCancelFeeOptions(data) {
        this.serviceCloseCancelFeeOptions = [];
        if (data.listServiceCloseCancelFeeEnum && data.listServiceCloseCancelFeeEnum.enumValues) {
          data.listServiceCloseCancelFeeEnum.enumValues.map(_value => {
            this.serviceCloseCancelFeeOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.closeCancelFee.options = this.serviceCloseCancelFeeOptions;
        }
      },
      getServiceCloseEtfWaiveReasonOptions(data) {
        this.serviceCloseEtfWaiveReasonOptions = [];
        if (data.listServiceCloseEtfWaiveReasonEnum && data.listServiceCloseEtfWaiveReasonEnum.enumValues) {
          data.listServiceCloseEtfWaiveReasonEnum.enumValues.map(_value => {
            this.serviceCloseEtfWaiveReasonOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.closeEtfWaiveReason.options = this.serviceCloseEtfWaiveReasonOptions;
        }
      },
      /**
       * ATLAS-685 New Application Workflow - Add fields needed to Service model
       * 
       * pendingResponsibility dropdown: getPendingResponsibilityEnumOptions()
       * declineReason dropdown: getDeclineReasonEnumOptions()
       */
      getPendingResponsibilityEnumOptions(data) {
        this.pendingResponsibilityOptions = [];
        if (data.listPendingResponsibilityEnum && data.listPendingResponsibilityEnum.enumValues) {
          data.listPendingResponsibilityEnum.enumValues.map(_value => {
            this.pendingResponsibilityOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.pendingResponsibility.options = this.pendingResponsibilityOptions;
        }
      },
      getDeclineReasonEnumOptions(data) {
        this.declineReasonOptions = [];
        if (data.listDeclineReasonEnum && data.listDeclineReasonEnum.enumValues) {
          data.listDeclineReasonEnum.enumValues.map(_value => {
            this.declineReasonOptions.push({
              id: _value.name,
              name: _value.name.replace(/\_/g, ' '),
            });
          });
          this.formConfig.fields.declineReason.options = this.declineReasonOptions;
        }
      },
      /**
       * ATLAS-848 Make "State" a drop down and not an open field
       * Methods for State & Country dropdown
       */
      getRegionEnumOptions(data) {
        this.regionOptions = [];
        if (data.listStatesEnum && data.listStatesEnum.enumValues) {
          data.listStatesEnum.enumValues.map(_value => {
            let _name = _value.name.replace(/US_|CA_/g, '');
            this.regionOptions.push({
              id: _value.name,
              name: _name.replace(/\_/g, ' ')
            });
          });
          
          //console.log('this.regionOptions ',this.regionOptions)
          this.formConfig.fields.addressPhysical.fields.region.options = this.regionOptions;
          this.formConfig.fields.addressMailing.fields.region.options = this.regionOptions;
        }
      },
      getCountryEnumOptions(data) {
        this.countryOptions = [];
        if (data.listCountriesEnum && data.listCountriesEnum.enumValues) {
          data.listCountriesEnum.enumValues.map(_value => {
            let _name = _value.name.replace(/US_|CA_/g, '');
            this.countryOptions.push({
              id: _value.name.replace(/_United_States|_Canada/g,''),
              name: _name.replace(/\_/g, ' ')
            });
          });
          
          //console.log('this.countryOptions ',this.countryOptions)
          this.formConfig.fields.addressPhysical.fields.country.options = this.countryOptions;
          this.formConfig.fields.addressMailing.fields.country.options = this.countryOptions;
        }
      },
      /**
       * ATLAS-1602: <Service><Financial currency>
       * All financial currency should be formatted in US dollars $100.00
       */
      formatCurrency(data) {
        if (data && data.getService) {
          //number formatter
          var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            //These options are needed to round to whole numbers
            minimumFractionDigits: 1,
            //maximumFractionDigits: 0,
          });

          if (data.getService.proposalStatementValue) {
            this.form.proposalStatementValue = formatter.format(data.getService.proposalStatementValue);
          }
          if (data.getService.avgTrxAmount) {
            this.form.avgTrxAmount = formatter.format(data.getService.avgTrxAmount);
          }
          if (data.getService.busSalesLimitM) {
            this.form.busSalesLimitM = formatter.format(data.getService.busSalesLimitM);
          }
          if (data.getService.busTicketAvg) {
            this.form.busTicketAvg = formatter.format(data.getService.busTicketAvg);
          }
          if (data.getService.busTicketMax) {
            this.form.busTicketMax = formatter.format(data.getService.busTicketMax);
          }
        }
      },
      async getAccount(accountId) {
        return new Promise((resolve, reject) => {
          let result = {};
          API.graphql(graphqlOperation(queries['getAccount'], {id: accountId}))
            .then(response => {
              result.id = response.data.getAccount.id;
              result.name = response.data.getAccount.name;
              resolve(result);
            })
            .catch(error => {
              this.$c.log(error);
              resolve(null);
            });
        })
      },
      async relateCaseServiceFilter() {   
        let result = null;
        let query = {"caseServiceServiceId": {"eq": this.$route.params.id }}
        const esQuery = { esQuery: JSON.stringify(query) };
          let operation = graphqlOperation(queries['searchCaseServices'], { limit: 9999, filter: query });
          API.graphql(operation)
            .then(async response => {
              console.log('searchCaseServices response ',response)
              let filters = [];
              let caseIds = [];
              let items = this.$reduce(response, 'data.searchCaseServices.items');
              
              // get all tasks in the connected cases and make id based filter
              // for use with elasticsearch
              for (let i = 0; i < items.length; i++) {
                let apiError = null;
                let itemCaseId = this.$reduce(items[i], 'case.id');
                
                // get case with tasks
                let editCaseOpeartion = graphqlOperation(queries_custom['editCase'], {
                  id: itemCaseId
                });
                let editCaseResponse = await API.graphql(editCaseOpeartion).catch(err => apiError = err);
                
                // if there are no errors then add related task ids to filter
                if (!apiError) {
                  let caseTaskItems = this.$reduce(editCaseResponse, 'data.getCase.tasks.items');
                  if (caseTaskItems && caseTaskItems.length) {
                    caseTaskItems.map(_task => filters.push({ match: { id: _task.id } }));
                  }
                }
                caseIds.push(itemCaseId);
              }
              
              // save case ids - this is passed to tasks tab for reference
              // Commented due to ATLAS-1439
              //this.$set(this.tasksList, 'caseIds', caseIds);
              
              if(!filters.length){
                filters.push({"match": {"taskCaseId": -1}});
              }
              result = { esQuery: JSON.stringify({
                    bool: {
                      must: [
                        { bool: { should: filters } }
                      ]
                    }
                })
              }
              this.serviceCaseIds = result;
            })
            .catch(err => {
              this.serviceCaseIds = { esQuery: JSON.stringify({
                    bool: {must: [{ bool: { should: [{"match": {"taskCaseId": -1}}] } }]}})
              };
              console.log('error ',err)
            });
      },
      /**
       * ATLAS-821 Workflow Updates from demo feedback- Field Validations
       * Show validation error based on Status
       */
      validateStatus() {
        let msg = "";
        if(this.form.status === "Processing_Live" && !this.form.dateFirstProcessing) {
          msg = "You must enter a Processing Live Date";
        }
        if(this.form.status === "Closed" && !this.form.closeDate) {
          msg = "You must enter a Closed Date";
        }

        if(msg) {
          Swal.fire({
            title: "Validation Error",
            text: msg,
            confirmButtonClass: "md-button md-success btn-fill",
            buttonsStyling: false
          });
        }
      },
      async getChanges() {
        let response = null;
        let error = null;
        let nextToken = true;
        this.changeArr = [];
        let caseIdFilterArr = [];
        this.caseIds.forEach(caseId => {
          let pushObj = {"and": [{"modelName": {"eq":"Case"}},{"modelId": {"eq":caseId}}]};
          caseIdFilterArr.push(pushObj);
        });
        if (this.recordData && this.recordData.id) {
          caseIdFilterArr.push({
            and: [
              { modelName: { eq: 'Service' } },
              { modelId: { eq: this.recordData.id } },
            ]
          });
        }
        let params = {
          limit:999,
        };
        if (caseIdFilterArr && caseIdFilterArr.length) {
          params.filter = { or: caseIdFilterArr }
        }
        this.isPromisePending =  true;
        while (nextToken) {
          error = null;
          await API.graphql(graphqlOperation(queries["searchChanges"], params))
          .then(result => {
            console.log(result);
            result.data.searchChanges.items.forEach(change => {
              this.changeArr.push(change);              
            });
            if (
              result.data.searchChanges.items.length
              && result.data.searchChanges.items.length <= 999
            ) {
              nextToken = 999;
            } else {
              nextToken = null;
            }
          })
          .catch(err => {
            error = err
            console.log(error);
            error.data.searchChanges.items.forEach(change => {
              this.changeArr.push(change);              
            });
            nextToken = err.data.searchChanges.nextToken;
          });
          params.nextToken = nextToken;
        }
        this.isPromisePending =  false;
        console.log("this.changeArr", this.changeArr);
        this.generateChangeFeed();
        this.loadDeepLinkMessageOrNote();
        this.scrollToHash();
      },
      generateChangeFeed() {
        this.messagesAndNotes = [];
        if(this.$route.params.id) {
          let items = this.mergeMessagesAndNotes(this.updateFormData);
          this.sortMessagesAndNotes(items);
          this.messagesAndNotes = items;
        }
        if (this.changeArr) {
          let items = [];
          let filterChange = ['caseUserId','status', 'taskId', 'subject']
          
          this.$loopo(this.changeArr, (_changeItems, key) => {
            const change = JSON.parse(JSON.stringify(_changeItems));
            let updateChangeItem = {};
            try {
              updateChangeItem = JSON.parse(change.change);
              if ('object' !== typeof updateChangeItem) {
                try {
                  let changeJsonStr = change.change
                    .replace(/^"/, '')
                    .replace(/"$/, '')
                    .replace(/\\/ig, '')
                  updateChangeItem = JSON.parse(changeJsonStr);
                } catch (e) {
                  updateChangeItem = {};
                }
              }
            } catch (e) {
              updateChangeItem = {};
            }
            let changeKey = Object.keys(updateChangeItem);
            if((change.action == "modify") || (change.action == "insert") || (change.action == "remove")) {
              
              const compareChanges = filterChange.filter(element => {
                return (
                  changeKey.includes(element)
                  || (updateChangeItem.fromModelType === 'Service' && updateChangeItem.toModelType === 'Attachment')
                );
              });
              if(compareChanges.length >= 1) {
                let activity = this.arrangeChange(updateChangeItem, change.action);
                if(activity && activity.length && 'object' == typeof activity) {
                  activity.forEach(_activity => {
                    const newChange = _.cloneDeep(change);
                    newChange._type = 'change';
                    newChange._activity = _activity;
                    if (updateChangeItem.taskId && updateChangeItem.taskSubject) 
                      newChange._task = {id:updateChangeItem.taskId, subject:updateChangeItem.taskSubject};
                    if (updateChangeItem.caseId && updateChangeItem.caseSubject) 
                      newChange._case = {id:updateChangeItem.caseId, subject:updateChangeItem.caseSubject};
                    if(change.action == 'insert' && updateChangeItem.subject) {
                      if(change.modelName == 'Case') {
                        newChange._case = {id:change.modelId, subject:updateChangeItem.subject};
                      }
                      if(change.modelName == 'Task') {
                        newChange._task = {id:change.modelId, subject:updateChangeItem.subject};
                      }
                    }
                    this.messagesAndNotes.push(newChange);
                  });
                }
              }
            } 
          });

          const comments = this.$reduce(this, 'recordData.comments.items');
          const isInternalUser = this.$Session.isInternalGroupMember
          if (comments && comments.length) {
            for (let i = 0; i < comments.length; i++) {
              if (comments[i] && comments[i].parentComment && comments[i].parentComment.id) {
                continue;
              }
              const attachmentFilter = {
                relationCommentId: { eq: comments[i].id },
                toModelType: { eq: 'Attachment' },
              };
              const data = {
                ...comments[i],
                _type: 'serviceComment',
              };
              this.getAttachments(attachmentFilter)
                .then(attachments => this.$set(data, 'attachment', attachments))
                .catch(err => console.log('getAttachments error ', err));
              this.messagesAndNotes.push(data);
            }
          }

          this.sortMessagesAndNotes(this.messagesAndNotes);
        }
      },
      async getUserList() {
        console.log("getUserList function");
        const users = [];
        const limit = 999;
        let hasNext = true;
        let nextToken = 0;
        while (hasNext) {
          // fetch users
          const response = await API.graphql(graphqlOperation(queries["searchUsers"], { limit, nextToken }));
          const items = this.$reduce(response, 'data.searchUsers.items') || [];
          // format response and add to list
          for (const _item of items) {
            users.push({
              id : _item.id,
              name: _item.given_name +"_"+ _item.family_name,
              email: _item.email
            });
          }          
          // if number of items is equal to limit then next page is available
          hasNext = limit === items.length;
          nextToken += limit;
        }
        // assign users
        this.userListItems = users;
      },
      onMessagesAndNotesFilterChange(items) {
        if (!this.isDeepLinkLoadInProgress) {
          this.messagesAndNotesPage = 1;
        }
        this.isDeepLinkLoadInProgress = false;
        this.messagesAndNotesFiltered = items;

        let message = items.find(_item => 'message' == _item._type);
        if (!message || !message.id) {
          message = {};
        }
        this.defaultItem = message;
      },
      onReply (mode, replyItem, blockChangeTab, skipScroll) {
      },
      onCommentEdit (noteItem) {
      },
      async onShowAttachment (message, showAttachmentStatus) {
        const messageId = message.id;

        // find message in record data
        let messageToUpdate = null;
        
        // loop all service cases
        for (let i = 0; i < this.recordData.cases.items.length; i++) {
          const _case = this.recordData.cases.items[i].case;
          if (!_case || !_case.messages || !_case.messages.items || !_case.messages.items.length) {
            continue;
          }
          // loop all messages in current case inside loop
          for (let j = 0; j < _case.messages.items.length; j++) {
            const _message = _case.messages.items[j];
            if (_message.id === messageId) {
              messageToUpdate = _message;
              break;
            }
          }
        }        

        // if found then update showAttachmentStatus
        if (messageToUpdate) {
          this.$set(messageToUpdate, 'showAttachmentStatus', showAttachmentStatus);
        }
        
        // if attachment is not in list of fetched attachments
        if(this.attachmentFetchedMessagesId.indexOf(messageId) == -1) {
          // push message in attachmentFetchedMessagesId
          this.attachmentFetchedMessagesId.push(messageId);
          this.fetchAttachmentPromisePending = true;

          // message attachments query
          const operation = graphqlOperation(queries_custom.searchCaseAttachments, {
            filter: {
              esQuery: JSON.stringify({
                bool: {
                  must: [
                    { match_phrase: { relationMessageId: messageId } },
                    { match_phrase: { fromModelType: 'Message' } },
                    { match_phrase: { toModelType: 'Attachment' } },
                  ]
                }
              })
            },
            limit: 999,
          });

          // call graphql and search for attachments
          let error = null;
          const response = await API.graphql(operation).catch(err => error = err);

          // error fetching attachments
          if (error) {
            this.fetchAttachmentPromisePending = false;
            // this.updateFormAfter({ getService: this.recordData });
            // this.generateChangeFeed();
            return;
          }

          // get attachment items
          const attachmentItems = this.$reduce(response, 'data.searchRelations.items');
          const attachments = [];

          // scan all valid attachments
          for (const _attachment of attachmentItems) {
            // if attachment data is not present then bail
            if (!_attachment || !_attachment.attachment || !_attachment.attachment.id) {
              continue;
            }

            // get attachment data
            const attachmentObj = _attachment.attachment;

            // check attachment permission
            attachmentObj.hasPermission = true;
            if (attachmentObj.internal && !this.$Session.isInternalGroupMember) {
              attachmentObj.hasPermission = false;
            }

            // get token based short time public url
            if (attachmentObj.hasPermission && attachmentObj.s3Path) {
              attachmentObj.link = await Storage.get(attachmentObj.s3Path, {
                bucket: aws_exports.aws_user_files_s3_bucket,
                region: aws_exports.aws_user_files_s3_bucket_region,
              });
            }

            // add attachment
            attachmentObj.fileName = attachmentObj.name;
            attachments.push(attachmentObj);
          }

          // update target message with attachment data
          if (messageToUpdate) {
            this.$set(messageToUpdate, 'attachments', attachments);
          }
          
          // update feed and promise status
          this.fetchAttachmentPromisePending = false;
          this.generateChangeFeed();
        } else {
          this.generateChangeFeed();
        }
      },
      mergeMessagesAndNotes(data) {
        const items = [];        
        data.getService.cases.items.forEach(serviceCase => {
          if (serviceCase && serviceCase.case && serviceCase.case.messages.items) {
            serviceCase.case.messages.items.map(_message => {
              const message = JSON.parse(JSON.stringify(_message));
              message._type = 'message';
              message._case = {id:serviceCase.case.id, subject:serviceCase.case.subject};
              items.push(message);
            });
          }
          if (serviceCase && serviceCase.case && serviceCase.case.comments && serviceCase.case.comments.items) {
            serviceCase.case.comments.items.map(_comment => {
              const comment = JSON.parse(JSON.stringify(_comment));
              comment._type = 'caseComment';
              comment._case = {id:serviceCase.case.id, subject:serviceCase.case.subject};
              items.push(comment);
              const attachmentFilter = {
                relationCommentId: { eq: comment.id },
                toModelType: { eq: 'Attachment' },
              };
              this.getAttachments(attachmentFilter)
                .then(attachments => this.$set(comment, 'attachment', attachments))
                .catch(err => console.log('getAttachments error ', err));
            });
          }
          if (serviceCase && serviceCase.case && serviceCase.case.tasks.items) {
            serviceCase.case.tasks.items.map(_task => {
              _task.comments.items.map(_comment => {
                if(_comment.parentComment == null) {
                  const comment = JSON.parse(JSON.stringify(_comment));
                  comment._type = 'taskComment';
                  comment.task_id = _task.id;
                  comment.task_subject = _task.subject;
                  comment._task = {id:_task.id, subject:_task.subject};
                  comment._case = {id:serviceCase.case.id, subject:serviceCase.case.subject};
                  items.push(comment);
                  const attachmentFilter = {
                    relationCommentId: { eq: comment.id },
                    toModelType: { eq: 'Attachment' },
                  };
                  this.getAttachments(attachmentFilter)
                    .then(attachments => this.$set(comment, 'attachment', attachments))
                    .catch(err => console.log('getAttachments error ', err));
                }              
              });
            });
          }
        });
        return items;
      },
      /**
       * Add activity logs/feed in array per condition to show on feed tab
       */
      arrangeChange (changeItem, action) {
        if(typeof changeItem.taskId != "undefined")
          var taskName = changeItem.taskSubject ? changeItem.taskSubject : changeItem.taskId;
          var taskNameLink = "<a href=\"#/cases/" + changeItem.caseId + "#/tasks/" + changeItem.taskId + "\" target=\"_self\">" + taskName + "</a>"
          let activity = [];
        if(action == "modify") {
          if(typeof changeItem.status != "undefined") {
            const caseStatus = ['New', 'In_Progress', 'Closed_Completed', 'Closed_Unresolved', 'Merged', 'Closed_By_Workflow'];
            const serviceStatus = ['Prospect', 'App_Received', 'Pre_Submission', 'Withdrawn', 'Submitted', 'Sub_Withdrawn', 'Pending', 'Declined', 'Approved', 'Approved_Never_Live', 'Processing_Live', 'Closed', 'Seasonal_Hold'];

            //update feed if case status changed
            if (caseStatus.indexOf(changeItem.status) !== -1) {
              activity.push(" Changed the case status to - " + changeItem.status.replace(/_/g, " "));  
            } else if(serviceStatus.indexOf(changeItem.status) !== -1) {
              //update feed if service status changed
              activity.push(" Changed the service status to - " + changeItem.status.replace(/_/g, " "));
            }
          }
          if(typeof changeItem.caseUserId != "undefined") {
            let userName =  this.userListItems.filter(data =>  
              data.id === changeItem.caseUserId
            )
            if(userName.length != 0){
              var name = userName[0].name.replace(/_/g, ' ')
              activity.push(" Assigned the case to user " + name);
            } else 
            	activity.push(" Assigned the case to user " + changeItem.caseUserId);
          }
          if(typeof changeItem.taskId != "undefined") {
            if(typeof changeItem.updatedTask != "undefined") {
              if(typeof changeItem.updatedTask.taskUserId != "undefined"){
                let userName = this.userListItems.filter(data => data.id === changeItem.updatedTask.taskUserId)
                if(userName.length != 0){
	                var name = userName[0].name.replace(/_/g, ' ')
	                activity.push(" Assigned the task to user " + name + " " + taskNameLink);
	            } else 
	            	activity.push(" Assigned the task to user " + changeItem.updatedTask.taskUserId + " to task - " + taskNameLink);		
              } else if (typeof changeItem.updatedTask.status != "undefined") {
                activity.push(" Changed the task - " + taskNameLink + " status to " + changeItem.updatedTask.status);
              } else if (typeof changeItem.updatedTask.taskCaseId != "undefined") {
                activity.push(" Assigned the task - " + taskNameLink);
              }
            } else {
              activity.push(" Assigned the task - " + taskNameLink);
            }
          }
        }
        if(action == "insert") {
          // add attachment feed
          if(
            typeof changeItem.name !== 'undefined'
            && typeof changeItem.fromModelType !== 'undefined'
            && typeof changeItem.toModelType !== 'undefined'
          ) {
            activity.push(` attached a file ${changeItem.name}`);
          }
          
          if(typeof changeItem.taskId != "undefined"){
            if(typeof changeItem.updatedTask == "undefined") {
              activity.push(" Created a new task - " + taskNameLink);
            }
          } else if (typeof changeItem.subject != "undefined") {
            if (typeof changeItem.status != "undefined") {
              activity.push(" Change the status - " + changeItem.status.replace(/_/g, " "));
            }
            if(typeof changeItem.caseUserId != "undefined"){
              let userName =  this.userListItems.filter(data =>  
              data.id === changeItem.caseUserId
              )
              if(userName.length != 0){
                var name = userName[0].name.replace(/_/g, ' ')
                activity.push(" Assigned the case to user " + name);
              } else 
            	activity.push(" Assigned the case to user " + changeItem.caseUserId);	  	
            }
            activity.push(" Created a new Case - " + changeItem.subject);
          }
        } 
        if(action == "remove") {
          if(typeof changeItem.taskId != "undefined"){
            if(typeof changeItem.updatedTask == "undefined") {
              activity.push(" Deleted a task - " + taskName);
            }
          }
          //remove attachment feed
          if(
            typeof changeItem.name !== 'undefined'
            && typeof changeItem.fromModelType !== 'undefined'
            && typeof changeItem.toModelType !== 'undefined'
          ) {
            activity.push(` deleted a file ${changeItem.name}`);
          }
        }
        return activity;
      },
      sortMessagesAndNotes(items) {
        items.sort((prev, next) => {
          const prevDate = new Date(prev.createdAt).getTime();
          const nextDate = new Date(next.createdAt).getTime();
          if (prevDate < nextDate) {
            return 1;
          }
          if (prevDate > nextDate) {
            return -1;
          }
          return 0;
        });
      },
      loadDeepLinkMessageOrNote() {
        const hashId = this.$route.hash.replace('#', '');
        const index = this.messagesAndNotes.findIndex((_item) => hashId == _item.id);
        if (-1 === index) {
          return;
        }
        this.isDeepLinkLoadInProgress = true;
        this.messagesAndNotesPage = Math.ceil((index + 1) / this.messagesAndNotesItemsPerPage);
      },
      loadNextMessagesAndNotes() {
        this.messagesAndNotesPage++;
      },
      onMessagesAndNotesFilterChange(items) {
        if (!this.isDeepLinkLoadInProgress) {
          this.messagesAndNotesPage = 1;
        }
        this.isDeepLinkLoadInProgress = false;
        this.messagesAndNotesFiltered = items;

        let message = items.find(_item => 'message' == _item._type);
        if (!message || !message.id) {
          message = {};
        }
        this.defaultItem = message;
      },

      getLinkConfigs() {
        if (this.$Session.isAdminGroupMember) {
          this.auditLogList.linkConfigs = [
            {
              name: 'user',
              hrefCallback: (column, name, item) => {               
                return '#/users/' + (item.user ? item.userId : "" );
              },
              titleCallback: (column, name, item) => {                           
                  return item.user                
              },
            }
          ]

          if (this.$refs.auditLogListRef) {
            this.$refs.auditLogListRef.refresh();
          }

        }
      },
      removeFile(fileIndex){
        this.attachmentData.splice(fileIndex, 1)
      },
      getCommentAsPlainText() {
        return this.comment.body
          .replace(/(<([^>]+)>)/gi, '')
          .replace(/&nbsp;/ig, '')
          .replace(/\s{2,}/ig, ' ')
          .trim();
      },
      async storeAttachmentsOnly() {
        // prepare variables
        let error = null;
        this.attachments = this.attachmentData;
        
        // store attachments and relations
        await this.add(this.getCommentAttachmentRelations()).catch(err => error = err);
        if (error) {
          this.showSnackbar(null, error);
          return;
        }
        
        // show snackbar message and cleanup
        this.showSnackbar('Comment added successfully');
      },
      cleanupAfterComment() {
        this.commentId = null
        this.attachments = []
        this.placeHolder()
        this.promisePending = false;
        this.clearCommentEditor();
      },
      showSnackbar(msg, err) {
        let str = 'Something went wrong - please try again!';
        if (msg) {
          str = msg;  
        } else if (err && err.message) {
          str = err.message;
        }
        this.snackbar.icon = 'done';
        this.snackbar.content = str;
        this.snackbar.status = true;
      },
    },
    beforeRouteLeave (to, from, next) {
      this.$notifyClear(this.noticationTimeStamp);
      this.noticationTimeStamp = [];
      next();
    },
    watch: {
      'form.isWithdrawalAccount'(){
        window.dispatchEvent(new Event('resize'));
      },
      '$Session.isAdminGroupMember'(){
        this.getLinkConfigs();
      },
      'recordData'() {
        if(this.recordData) {
          this.caseIds = _.map(this.recordData.cases.items, 'case.id');
          this.getChanges();
        }
      },
      '$route.params': function () {
        this.$notifyClear(this.noticationTimeStamp);
        this.noticationTimeStamp = [];
        this.shouldShowAlertMessage = true;
        this.shouldShowAccountAlertMessage = true;
      },
      /**
       * ATLAS-685 New Application Workflow - Add fields needed to Service model
       * Clear text/select input if they are hidden based on status
       */
      'form.status': {
        immediate: true,
        handler: function() {
          //ATLAS-821 Workflow Updates from demo feedback- Field Validations
          if(this.form.status === "Closed" || this.form.status === "Processing_Live") {
            this.validateStatus();
          }

          if (this.form.status !== "Pending") {
            this.form.pendingResponsibility = '';
          }
          if (this.form.status !== 'Declined') {
            this.form.declineReason = '';
            this.form.declineNotes = '';
          }
        }
      },

      '$route.meta.tab': {
        immediate: true,
        handler: function() {
          if (this.$route.meta.tab == "tasks") {
           this.relateCaseServiceFilter();
          }
        }
      },
      /**
       * ATLAS-791
       * Service CRUD : UI issue on add new service page
       */
      'form.closeRequested': {
        handler: function() {
          window.dispatchEvent(new Event('resize'));
        }
      },
      /**
       * ATLAS-848 Make "State" a drop down and not an open field
       * 
       * Following four watchers will set the Country based on State selection &
       * load specific State list based on Country selection
       */
      "$v.form.addressPhysical.fields.region.$model": {
        immediate: true,
        handler: function() {
          if (this.form.addressPhysical.fields.region) {
            let countryCode = this.form.addressPhysical.fields.region.split("_");
            this.form.addressPhysical.fields.country = countryCode[0];
          }
        }                       
      },
      "$v.form.addressPhysical.fields.country.$model": {
        immediate: true,
        handler: function() {
          if (this.form.addressPhysical.fields.country) {
            if (this.addrPhysicalCountry && this.addrPhysicalCountry != this.form.addressPhysical.fields.country) {
              this.form.addressPhysical.fields.region = "";
            }

            let newRegionOptions = [];
            this.regionOptions.forEach(item => {
              if(item.id.includes(this.form.addressPhysical.fields.country + "_")) {
                newRegionOptions.push(item);
              }
            });

            this.addrPhysicalCountry = this.form.addressPhysical.fields.country;
            this.formConfig.fields.addressPhysical.fields.region.options = newRegionOptions;
          }
        }                       
      },
      "$v.form.addressMailing.fields.region.$model": {
        immediate: true,
        handler: function() {
          if (this.form.addressMailing.fields.region) {
            let countryCode = this.form.addressMailing.fields.region.split("_");
            this.form.addressMailing.fields.country = countryCode[0];
          }
        }                       
      },
      "$v.form.addressMailing.fields.country.$model": {
        immediate: true,
        handler: function() {
          if (this.form.addressMailing.fields.country) {
            if (this.mailingCountry && this.mailingCountry != this.form.addressMailing.fields.country) {
              this.form.addressMailing.fields.region = "";
            }

            let newRegionOpts = [];
            this.regionOptions.forEach(item => {
              if(item.id.includes(this.form.addressMailing.fields.country + "_")) {
                newRegionOpts.push(item);
              }
            });

            this.mailingCountry = this.form.addressMailing.fields.country;
            this.formConfig.fields.addressMailing.fields.region.options = newRegionOpts;
          }
        }                       
      },

      /**
       * ATLAS-745 AT-I-7 Service -> Children products need to be displayed UNDER their parent product
       * Add row for Product child level 1
       */
      'productsList.currentSort': {
        handler: function() {
          this.$refs.productsListRef.refresh();
        }
      },
      'productsList.currentSortOrder': {
        handler: function() {
          this.$refs.productsListRef.refresh();
        }
      },
      
    }
  }
</script>

<style lang="scss">

  .md-tabs .md-tabs-navigation {
    padding-left: 15px;
    color: black;
    display: none;

    .md-tab-nav-button.md-button {
      color: black !important;

      &.active {
        color: black !important;
        border-bottom: 2px solid black;
      }
    }
  }

  .md-content .md-tabs-container .md-tab > .md-layout-item {
    padding-left: 0;
    padding-right: 0;
  }

  .setTop{
    margin-top: 80px;
  }

  [name="giftVendorNum"],
  [name="checksCntAvgM"] {
    margin-top: 16px;
  }

  .topNavTabs.tabContent .md-content.md-theme-default.md-tabs-content {
    margin-top: 80px !important;    
    .md-tabs-container .md-tab{
        padding: 75px 0 0 0 !important;
    }
  }

  .md-layout.case-view-wrapper {
    /* add this for mobile: margin-top: -12px; */
    margin-top: 0px;
  }

  .dynamicList-loading {
    position: absolute;
    top: 20px;
    left: 50%;
    transform:translateX(-50%);
    bottom: auto;
    right: auto;
    display: block;
  }
  .md-dialog-actions {
    justify-content: flex-start;
  }

form {
  .serviceStatusField,
  .serviceNamePreviousField {
    width: 51%;

    &> div {
      width: 98%;
    }
  }
}

  #tab-attachments .md-alignment-center-right {
    padding: 0 0.5rem;
  }
</style>

<style lang="scss" scoped>
  .md-button:not(.md-just-icon) .md-button-content i {
    font-size: 10px !important;
  }
  .badge {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 4px;
    right: 15px;
    min-width: 24px;
    min-height: 24px;
    background-color: #3E5877 !important;
    border-radius: 50%;
    color: #fff;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    letter-spacing: -.05em;
  }
</style>
